/**
 * クラス名：会社設定画面
 * 作成者：チュー
 * 作成日：2023/07/24
 * バージョン：1.0
 */
import { Input, Row, Col, Select, Button, Typography, Checkbox, Modal, Popover, Layout, ColorPicker } from 'antd';
import React, { Component, useState, useRef, forwardRef, useEffect, useImperativeHandle } from 'react';
import dayjs from 'dayjs';
import axios from 'axios';
import {
  CaretUpOutlined,
  CaretDownOutlined,
  PlusCircleFilled,
  CloseCircleFilled,
  EditOutlined,
  CloseOutlined,
  CloudDownloadOutlined,
} from '@ant-design/icons';
import { Table } from 'react-bootstrap';
import { getAccessToken, getDefaultJellDOptions, isDecimal, toDecimal, updateAccessToken } from '../common/Common';
import { ErrorMessage } from '../common/Message';
import {
  authorizeError,
  error,
  confirmModalTitle,
  commonModal,
  commonFooter,
  confirmUpdateContent,
  complete,
  commonDeleteFooter,
  confirmDeleteContent,
  commonResponsiveConfirmModal,
  confirmCreateContent,
} from '../common/CommonModal';
import {
  getExistCompanySetting,
  getExcelDatabyUseType,
  getExistUserSetting,
  getS3FileContent,
  deleteS3FileContent,
  downloadS3FileContent,
} from '../common/CommonAPI';

import { StatusCodes } from 'http-status-codes';
import {
  CompanyRole,
  Continuous,
  CurrencySymbols,
  PrintTypes,
  RoundUpMethods,
  SaveSameType,
  dxfTypes,
  languages,
  timeZones,
} from '../common/enums';
import { saveSameTypes } from '../common/Constant';
import UserMasterList from './UserMasterList';

const csvFilesData = [
  { key: 1, title: '生産管理連携', useFor: '個別出力', examples: '図面、品番、名称、金額、工程1、工程2、' },
  { key: 2, title: '親部品リスト', useFor: 'リスト出力', examples: '図面、品番、名称、金額、工程1、工程2、' },
];

const curSymbol = {
  0: '¥',
};

const riyoushin = {
  0: '個別帳票',
  1: 'リスト帳票',
};

const parentnamingConditions = [
  { id: 0, value: 0, label: ' ' },
  { id: 1, value: 1, label: '年月日' },
  { id: 2, value: 2, label: '時分秒' },
];

const namingConditions = [
  { id: 0, value: 0, label: ' ' },
  { id: 1, value: 1, label: '年月日' },
  { id: 2, value: 2, label: '時分秒' },
  { id: 3, value: 3, label: '材料名' },
  { id: 4, value: 4, label: '材質名' },
  { id: 5, value: 5, label: '表面保護' },
  { id: 6, value: 6, label: '板厚' },
  { id: 7, value: 7, label: '材料サイズX' },
  { id: 8, value: 8, label: '材料サイズY' },
  { id: 9, value: 9, label: '部品サイズX' },
  { id: 10, value: 10, label: '部品サイズY' },
  { id: 11, value: 11, label: '親部品図番' },
  { id: 12, value: 12, label: '親部品名称' },
  { id: 13, value: 13, label: '0000*' },
];

const InitNameTypes = {
  //　図番
  DrawingNo: 0,
  // 名称
  PartName: 1,
  // 見積番号
  EstimateNo: 2,
  // 子部品図番
  ChildDrawingNo: 3,
  // 子部品名称
  ChildPartName: 4,
};

const presetColors = [
  '#f5222d',
  '#fa541c',
  '#fa8c16',
  '#fadb14',
  '#52c41a',
  '#13c2c2',
  '#1677ff',
  '#2f54eb',
  '#722ed1',
  '#eb2f96',
];

const ALLOWED_REGEX = /^[\x21-\x7E]*$/; // 英数字＋半角記号制御

const CompanySetting = forwardRef((props, ref) => {
  const [selectedAdminItem, setSelectedAdminItem] = useState();
  const workFileInputRef = useRef(null);
  const pcFileInputRef = useRef(null);
  const excelFileRef = useRef(null);
  const reportOutputFolderRef = useRef(null);
  const [fileName, setFileName] = useState('');
  const [pcFileName, setPCFileName] = useState('');

  const [individualExcelQuickOutput, setIndividualExcelQuickOutput] = useState(true);

  const [individualFormatId, setIndividualFormatId] = useState();
  const [listExcelQuickOutput, setListExcelQuickOutput] = useState(true);
  const [listFormatId, setListFormatId] = useState();

  const [isUseSameName, setIsUseSameName] = useState();
  const [saveSameType, setSaveSameType] = useState(SaveSameType.EstimateNo);

  // CSV出力
  const [individualCSVQuickOutput, setIndividualCSVQuickOutput] = useState(true);

  const [listCSVQuickOutput, setListCSVQuickOutput] = useState(true);

  const [mitsumoriVal, setMitsumoriVal] = useState('切上げ');
  const [currency, setCurrency] = useState('￥');

  const [excelFiles, setExcelFiles] = useState('');

  const [dragging, setDragging] = useState(false);
  const [files, setFiles] = useState([]);

  const [excelFilesList, setExcelFilesList] = useState([]);

  const [csvFilesList, setCSVFilesList] = useState(csvFilesData);

  const [CSVSettingModal, setCSVSettingModal] = useState(false);

  const [adminLanguage, setAdminLanguage] = useState('日本語');
  const [adminTimeZone, setAdminTimeZone] = useState('(GMT+0:900) Asia/Tokyo');

  const [companySettingObj, setCompanySettingObj] = useState([]);
  const [companySettingBefore, setCompanySettingBefore] = useState([]);
  const [isExist, setIsExist] = useState(false);
  const [saveConfirm, setSaveConfirm] = useState(false);
  const [uploadedFileLst, setUploadedFileLst] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadComplete, setUploadComplete] = useState(false);

  //   見積金額切上げ桁数
  const [estimatedAmount, setEstimatedAmount] = useState(0);
  //   小数点以下桁数
  const [decimalPlaces, setDecimalPlaces] = useState(0);
  /* const [excelFilesList, setExcelFilesList] = useState([]); */

  const [parentDrawingNo, setParentDrawingNo] = useState({});
  const [parentName, setParentName] = useState({});
  const [parentEstimateNo, setParentEstimateNo] = useState({});
  const [childDrawingNo, setChildDrawingNo] = useState({});
  const [childName, setChildName] = useState({});

  const [userSettingInfo, setUserSettingInfo] = useState([]);

  // IQX_WEBEST-273 帳票のExcelをダウンロードしたい IQX_WEBEST-274 帳票のExcelを削除したい
  const [isFileDownloadModal, setIsFileDownloadModal] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteFileNm, setDeleteFileNm] = useState('');
  const [deleteFileId, setDeleteFileId] = useState(0);
  const [isInnerDiameterIncluded, setIsInnerDiameterIncluded] = useState(false);
  // 2025-07-22 IQX_WEBEST-443 機能追加の要望⑤「複数子部品追加登録」
  const [isAddMultipleChildParts, setIsAddMultipleChildParts] = useState(false);
  // 2025-07-23 IQX_WEBEST-439 機能追加の要望①「空送線計算有」
  const [isAirLineCalculation, setIsAirLineCalculation] = useState(false);
  // 2025-07-23 IQX_WEBEST-442 機能追加の要望④「ブランク加工下穴計算有」
  const [isBlankDrillingCalculation, setIsBlankDrillingCalculation] = useState(false);
  // 2025-07-23 IQX_WEBEST-441 機能追加の要望③「同一線上曲げ線をまとめる」
  const [isCollinearBendingLine, setIsCollinearBendingLine] = useState(false);
  // 2025-07-23 IQX_WEBEST-440 機能追加の要望②「外形線1本化処理計算」
  const [isSingleOutlineProcessingCalculation, setIsSingleOutlineProcessingCalculation] = useState(false);
  // 2025-08-04 IQX_WEBEST-439 機能追加の要望①「下敕き図面保存」
  const [isSaveDrawing, setIsSaveDrawing] = useState(false);

  const [regConfirm, setRegConfirm] = useState(false);
  const [companyMst, setCompanyMst] = useState({
    compNm: '',
    mailAddress: '',
    userNm: '',
    password: '',
  });
  const [userMst, setUserMst] = useState({
    mailAddress: '',
    userNm: '',
    password: '',
    userRole: '2',
  });

  const currentDateTime = dayjs().format('YYYY-MM-DD HH:mm:ss.SSSSSZ');

  const getFileList = async () => {
    var transformedFilesOption = [];
    try {
      const apiUrl = process.env.REACT_APP_BACKEND_API_URL + 'CompanySetting/getFileList';
      const accessToken = getAccessToken();
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
      });

      if (response.data && response.status === StatusCodes.OK) {
        var uploadedFiles = response.data;
        if (uploadedFiles?.length > 0) {
          transformedFilesOption = uploadedFiles?.map((fileName, index) => ({
            id: index + 1,
            value: uploadedFiles[index],
            label: uploadedFiles[index],
            fileId: uploadedFiles[index].replace(/\.[^/.]+$/, ''), // Removes file extension
          }));
        } else {
          transformedFilesOption.push(
            uploadedFiles?.map((fileName, index) => ({
              id: index + 1,
              value: '',
              label: '',
              fileId: '',
            }))
          );
        }
        return transformedFilesOption;
      } else if (
        response.data &&
        (response.status === StatusCodes.UNAUTHORIZED || response.status === StatusCodes.CONFLICT)
      ) {
        authorizeError(ErrorMessage().E006);
        throw new Error('Unauthorized or Conflict'); // Throw an error to indicate unauthorized or conflict
      } else if (response.data && response.status !== StatusCodes.OK) {
        error(ErrorMessage()[response.data?.messageCode]);
        throw new Error('Request failed with an error status'); // Throw an error for other error statuses
      }
    } catch (internal_err) {
      error(internal_err.message);
      throw internal_err; // Re-throw the error to propagate it to the caller
    }
  };

  useImperativeHandle(ref, () => ({
    getCompanySettingData: () => {
      return {
        companySettingData: companySettingObj,
        companySettingBefore: companySettingBefore,
        updatedExcelList: excelFilesList,
      };
    },
    updConfirmOkCompany: updConfirmOk,
  }));

  useEffect(() => {
    async function fetchData() {
      setSelectedAdminItem(props.selectedItem);
      var existedData = await getExistCompanySetting();
      var uploadedFiles = await getFileList();
      setUploadedFileLst(uploadedFiles);
      let userSettingInfo = await getExistUserSetting();
      if (userSettingInfo !== undefined && userSettingInfo?.length !== 0) {
        setUserSettingInfo(userSettingInfo[0]);
      }
      if (existedData?.length > 0 && existedData != []) {
        setIndividualExcelQuickOutput(existedData[0]?.printOutputs[PrintTypes.individual]?.isUseQuickOutput);
        setListExcelQuickOutput(existedData[0]?.printOutputs[PrintTypes.list]?.isUseQuickOutput);

        setIsUseSameName(existedData[0]?.environments?.isUseSameName);
        setSaveSameType(existedData[0]?.environments?.saveSameType);
        setExcelFilesList(
          existedData[0]?.excelFormats?.length == 0 || existedData[0]?.excelFormats == undefined
            ? [{ id: 0, title: '', useType: 0, fileName: uploadedFiles[0].value, fileId: uploadedFiles[0].fileId }]
            : existedData[0]?.excelFormats
        );
        setIsInnerDiameterIncluded(
          existedData[0]?.environments?.isInnerDiameterIncluded
            ? existedData[0]?.environments?.isInnerDiameterIncluded
            : false
        );

        // 2025-07-22 IQX_WEBEST-443 機能追加の要望⑤「複数子部品追加登録」
        setIsAddMultipleChildParts(
          existedData[0]?.environments?.isAddMultipleChildParts
            ? existedData[0]?.environments?.isAddMultipleChildParts
            : false
        );
        // 2025-08-04 IQX_WEBEST-439 機能追加の要望①「下敕き図面保存」
        setIsSaveDrawing(
          existedData[0]?.environments?.isSaveDrawing ? existedData[0]?.environments?.isSaveDrawing : false
        );

        // 2025-07-23 IQX_WEBEST-439 機能追加の要望①「空送線計算有」
        setIsAirLineCalculation(
          existedData[0]?.environments?.isAirLineCalculation
            ? existedData[0]?.environments?.isAirLineCalculation
            : false
        );

        // 2025-07-23 IQX_WEBEST-442 機能追加の要望④「ブランク加工下穴計算有」
        setIsBlankDrillingCalculation(
          existedData[0]?.environments?.isBlankDrillingCalculation
            ? existedData[0]?.environments?.isBlankDrillingCalculation
            : false
        );

        // 2025-07-23 IQX_WEBEST-441 機能追加の要望③「同一線上曲げ線をまとめる」
        setIsCollinearBendingLine(
          existedData[0]?.environments?.isCollinearBendingLine
            ? existedData[0]?.environments?.isCollinearBendingLine
            : false
        );

        // 2025-07-23 IQX_WEBEST-440 機能追加の要望②「外形線1本化処理計算」
        setIsSingleOutlineProcessingCalculation(
          existedData[0]?.environments?.isSingleOutlineProcessingCalculation
            ? existedData[0]?.environments?.isSingleOutlineProcessingCalculation
            : false
        );

        if (existedData[0]?.excelFormats?.length > 0) {
          var excelData = getExcelDatabyUseType(existedData[0]?.excelFormats);
          let teset =
            existedData[0]?.printOutputs[0]?.formatsId == 0
              ? excelData[0]?.length > 0
                ? excelData[0][0].fileName
                : ''
              : existedData[0]?.printOutputs[0]?.formatsId;
          setIndividualFormatId(teset);

          setListFormatId(
            existedData[0]?.printOutputs[1]?.formatsId == 0
              ? excelData[1]?.length > 0
                ? excelData[1][0].fileName
                : ''
              : existedData[0].printOutputs[1].formatsId
          );
          /* var excelData = getExcelDatabyUseType(existedData[0]?.excelFormats);
          existedData[0].printOutputs[0].formatsId = excelData[0]?.length > 0 && existedData[0].printOutputs[0].formatsId ==0  ? excelData[0][0].id : 0;
          existedData[0].printOutputs[1].formatsId =
            excelData[1]?.length > 0 && existedData[0].printOutputs[0].formatsId == 0 ? excelData[1][0].id : 0; */
        } else {
          setListFormatId('');
          setIndividualFormatId('');
          existedData[0].printOutputs[0].formatsId = 0;
          existedData[0].printOutputs[1].formatsId = 0;
        }
        // IQX_WEBEST-241 会社設定において見積データ、子部品データ追加時の自動入力される名称の変更する機能
        setParentDrawingNo(existedData[0]?.initNames?.parentInitNameInfo[0]);
        setParentName(existedData[0]?.initNames?.parentInitNameInfo[1]);
        setParentEstimateNo(existedData[0]?.initNames?.parentInitNameInfo[2]);
        setChildDrawingNo(existedData[0]?.initNames?.childInitNameInfo[0]);
        setChildName(existedData[0]?.initNames?.childInitNameInfo[1]);
        if (Object.keys(existedData[0]?.dxfOptionsSetting)?.length === 0) {
          existedData[0].dxfOptionsSetting = getDefaultJellDOptions();
        } else {
          if (existedData[0]?.dxfOptionsSetting) {
            existedData[0].dxfOptionsSetting = JSON.parse(existedData[0]?.dxfOptionsSetting);
          }
        }
        setCompanySettingObj(existedData[0]);
        setCompanySettingBefore(existedData[0] ? JSON.parse(JSON.stringify(existedData[0])) : []); // IQX_WEBEST-320 設定画面で保存を行った後の操作時に表示される注意ダイアログをやめたいです。
        setIsExist(true);
      } else {
        setExcelFilesList([{ id: 0, title: '', useType: 0, fileName: uploadedFiles[0].value, fileId: '' }]);
        let constantObj = {
          created: currentDateTime,
          modified: currentDateTime,
          languages: { language: 0, timeZone: 0 },
          environments: {
            workFolderPath: '',
            localSavePath: '',
            isUseSameName: true,
            saveSameType: SaveSameType.EstimateNo,
            isBacthPartsAdd: true,
            isEachConfirmSameProcess: true,
            roundUpDigits: 1,
            roundUpMethod: 0,
            decimalPlaces: 1,
            currencySymbol: 0,
          },
          initNames: { parentInitNameInfo: [], childInitNameInfo: [] },
          excelFormats: { id: 0, title: '', useType: 0, fileName: '', fileId: '' },
          csvFormats: { id: 0, title: '', useType: 0, fileName: '', fileId: '' },
          printOutputs: [
            {
              printType: PrintTypes.individual,
              isUseQuickOutput: true,
              formatsId: 0,
            },
            {
              printType: PrintTypes.list,
              isUseQuickOutput: true,
              formatsId: 0,
            },
          ],
          csvOutputs: { printType: 0, isUseQuickOutput: true, formatsId: 0 },
          info: { isUsed: true, sortNum: 0, remarks: '' },
          dxfTypeCode: 1,
          dxfOptionsSetting: getDefaultJellDOptions(),
        };
        setCompanySettingObj(JSON.parse(JSON.stringify(constantObj)));
        setCompanySettingBefore(JSON.parse(JSON.stringify(constantObj)));
        setListExcelQuickOutput(true);
        setIndividualExcelQuickOutput(true);
        setIsUseSameName(true);
        setSaveSameType(SaveSameType.EstimateNo);
        setListFormatId('');
        setIndividualFormatId('');
        setIsExist(false);
      }
    }
    fetchData();
  }, [props.selectedItem]);

  useEffect(() => {
    if (uploadedFileLst[0] !== undefined && uploadedFileLst[0]?.value != '' && uploadedFileLst?.length == 1) {
      setExcelFilesList([{ id: 0, title: '', useType: 0, fileName: uploadedFileLst[0]?.value, fileId: '' }]);
    }
  }, [uploadedFileLst]);

  const handleDragEnter = (event) => {
    event.preventDefault();
    setDragging(true);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'copy'; // Shows a "copy" cursor when dragging over the component
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleFileUpload = async (selectedFile) => {
    if (!selectedFile) {
      alert('Please select a file to upload.');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('file', selectedFile);

      const apiUrl = `${process.env.REACT_APP_BACKEND_API_URL}CompanySetting/uploadFile`;

      // Add authorization header with bearer token
      const accessToken = getAccessToken();
      const headers = {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${accessToken}`,
        'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
      };

      const response = await axios.post(apiUrl, formData, { headers });

      if (response && response.status === StatusCodes.OK) {
        complete('ファイルのアップロードは正常に完了しました。');
        var uploadFiles = await getFileList();
        setUploadedFileLst(uploadFiles);
        //setExcelFilesList([{ id: 0, title: '', useType: 0, fileName: uploadFiles[0].value, fileId: '' }]);
      } else if (
        response &&
        (response.status === StatusCodes.UNAUTHORIZED || response.status === StatusCodes.CONFLICT)
      ) {
        authorizeError(ErrorMessage().E006);
        return;
      } else if (response && response.status !== StatusCodes.OK) {
        error(ErrorMessage()[response?.messageCode]);
        return;
      }
    } catch (internal_error) {
      error(internal_error.message);
      /* console.error('Error uploading file:', error.response ? error.response.data : error.message); */
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);

    const droppedFiles = Array.from(event.dataTransfer.files);
    const excelFiles = droppedFiles?.filter(
      (file) => file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // for .xlsx files
    );

    if (excelFiles?.length > 0) {
      setFiles(excelFiles);
      handleFileUpload(excelFiles[0]);
    } else {
    }
  };

  const browseWorkFiles = () => {
    workFileInputRef.current.click();
  };
  const browsePCFiles = () => {
    pcFileInputRef.current.click();
  };
  const browseExcelFiles = () => {
    excelFileRef.current.click();
  };
  // IQX_WEBEST-273 帳票のExcelをダウンロードしたい IQX_WEBEST-274 帳票のExcelを削除したい
  const openDownloadFileModal = () => {
    setIsFileDownloadModal(true);
  };
  const browseIndividualFile = () => {
    reportOutputFolderRef.current.click();
  };

  const handleWorkFileChange = (event) => {
    const selectedFile = event.target.files[0];

    setFileName(selectedFile.webkitRelativePath);
  };
  const handlePCFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      // setPCFileName(selectedFile.name);
      setPCFileName(selectedFile.webkitRelativePath);
    } else {
      setPCFileName('');
    }
  };

  const handleExcelFileChange = (event) => {
    /* const selectedFile = event.target.files[0];
    if (selectedFile) {
      setExcelFiles(selectedFile.name);
      setSelectedFile(selectedFile);
    } else {
      setExcelFiles('');
    } */
    handleFileUpload(event.target.files[0]);
  };

  const adminLanguageSetting = (
    <>
      <Row className="mt-4">
        <label style={{ fontWeight: 800, fontSize: '13.5px' }}>言語とタイムゾーンの設定</label>
      </Row>
      <div style={{ marginLeft: '1.5rem' }} className="settingContent">
        <Row className="mt-2">
          <label>言語</label>
        </Row>
        <Row>
          <Col span={8}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={companySettingObj?.languages?.language}
              onChange={(e) => {
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  languages: {
                    ...prevData?.languages,
                    language: e,
                  },
                }));
              }}
            >
              {Object.entries(languages)?.map(([key, value]) => (
                <Select.Option key={value} value={value}>
                  {key}
                </Select.Option>
              ))}
            </Select>
            <Typography.Text type="secondary" style={{ fontSize: '11px', marginLeft: '5px' }}>
              ユーザー設定がされている場合、ユーザー設定が優先されます。
            </Typography.Text>
          </Col>
        </Row>
        <Row className="mt-4">
          <label>タイムゾーン</label>
        </Row>
        <Row>
          <Col span={8}>
            　{' '}
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={companySettingObj?.languages?.timeZone}
              onChange={(e) => {
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  languages: {
                    ...prevData?.languages,
                    timeZone: e,
                  },
                }));
              }}
            >
              {Object.entries(timeZones)?.map(([key, value]) => (
                <Select.Option key={value} value={value}>
                  {key === 'JP' ? '(GMT+0:900) Asia/Tokyo' : ''}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
        <Row style={{ marginTop: '4rem' }}>
          <Col span={8} style={{ textAlign: 'right' }}>
            <Button
              className="mainButton"
              onClick={() => {
                //setSaveConfirm(true);

                setSaveConfirm(userSettingInfo?.massages?.editOk);
                if (!userSettingInfo?.massages?.editOk) {
                  updConfirmOk();
                }
              }}
            >
              保存
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );

  const increaseEstimatedAmount = (lblName) => {
    if (lblName === 'estimate') {
      //setEstimatedAmount((prevCount) => prevCount + 1);
      setCompanySettingObj((prevData) => ({
        ...prevData,
        environments: {
          ...prevData?.environments,
          roundUpDigits: prevData?.environments?.roundUpDigits + 1,
        },
      }));
    } else {
      //setDecimalPlaces((prevCount) => prevCount + 1);
      setCompanySettingObj((prevData) => ({
        ...prevData,
        environments: {
          ...prevData?.environments,
          decimalPlaces: prevData?.environments?.decimalPlaces + 1,
        },
      }));
    }
  };
  const decreaseEstimatedAmount = (lblName) => {
    if (lblName === 'estimate') {
      // setEstimatedAmount((prevCount) => (prevCount > 0 ? prevCount - 1 : 0));

      setCompanySettingObj((prevData) => ({
        ...prevData,
        environments: {
          ...prevData?.environments,
          roundUpDigits: prevData?.environments?.roundUpDigits > 0 ? prevData?.environments?.roundUpDigits - 1 : 0,
        },
      }));
    } else {
      // setDecimalPlaces((prevCount) => (prevCount > 0 ? prevCount - 1 : 0));
      setCompanySettingObj((prevData) => ({
        ...prevData,
        environments: {
          ...prevData?.environments,
          decimalPlaces: prevData?.environments?.decimalPlaces > 0 ? prevData?.environments?.decimalPlaces - 1 : 0,
        },
      }));
    }
  };

  const editCSVSetting = () => {
    setCSVSettingModal(true);
  };
  const handleIncrease = (e, key, name) => {
    if (name === 'excel') {
      // const data= { key: 1, title: '', useFor: '', fileName: '', note: '' }
      const copyData = excelFilesList.slice(); // Create a copy of the original array

      const insertIndex = excelFilesList?.findIndex((item, index) => index === key);
      //const insertIndex = excelFilesList?.map((item,index)=> index ===key);
      const largestId = excelFilesList?.reduce((maxId, item) => {
        return item.key > maxId ? item.key : maxId;
      }, 0);

      if (insertIndex !== -1) {
        const data = {
          id: 0,
          title: '',
          useType: PrintTypes.individual,
          fileName: uploadedFileLst[0].value,
          fileId: '',
        };
        copyData.splice(insertIndex + 1, 0, data); // Insert the new object after the found index
        setExcelFilesList(copyData);
      }
    } else {
      const copyData = csvFilesList.slice(); // Create a copy of the original array

      const insertIndex = csvFilesList?.findIndex((item) => item.key === key); // Find the clicked index of the item
      const largestId = csvFilesList?.reduce((maxId, item) => {
        return item.key > maxId ? item.key : maxId;
      }, 0);

      if (insertIndex !== -1) {
        const data = {
          key: largestId + 1,
          title: '',
          useFor: '',
          examples: '',
        };
        copyData.splice(insertIndex + 1, 0, data); // Insert the new object after the found index
        setCSVFilesList(copyData);
      }
    }
  };
  const handleDecrease = (e, key, name) => {
    if (name === 'excel') {
      if (excelFilesList?.length > 1) {
        const updatedData = excelFilesList?.filter((item, index) => index !== key);
        setExcelFilesList(updatedData);
      }
    } else {
      if (csvFilesList?.length > 1) {
        const updatedData = csvFilesList?.filter((item, index) => index !== key);
        setCSVFilesList(updatedData);
      }
    }
  };
  const environmentSetting = (
    <>
      <Row className="mt-4">
        {/* <label style={{ fontWeight: 800, fontSize: '13.5px' }}>環境の設定</label> */}
        <label style={{ fontWeight: 800, fontSize: '13.5px' }}>保存時の設定</label>
      </Row>

      {/* <Row className="mt-2">
          <label>ワークフォルダ</label>
        </Row>
        <Row align="middle">
          <Col span={6}>
            <Input value={fileName}></Input>
          </Col>
          <Col span={1}>
            <input
              type="file"
              ref={workFileInputRef}
              style={{ display: 'none' }}
              onChange={handleWorkFileChange}
              directory=""
              webkitdirectory=""
              // webkitRelativePath
            />
            <Button className="referenceButton" onClick={browseWorkFiles} style={{ marginLeft: 3 }}>
              参照
            </Button>
          </Col>
        </Row>

        <Row className="mt-4">
          <label>PC保存フォルダ</label>
        </Row>
        <Row align="middle">
          <Col span={6}>
            <Input value={pcFileName}></Input>
          </Col>
          <Col span={1}>
            <input
              type="file"
              ref={pcFileInputRef}
              directory=""
              webkitdirectory=""
              style={{ display: 'none' }}
              onChange={handlePCFileChange}
            />
            <Button className="referenceButton" onClick={browsePCFiles} style={{ marginLeft: 3 }}>
              参照
            </Button>
          </Col>
        </Row>
        <Row className="mt-4">保存時の設定</Row>
        <Row className="mt-2">
          <Checkbox checked={saveZumen} onChange={(e) => setSaveZumen(e.target.checked)}>
            下敷き図面を保存する
          </Checkbox>
        </Row>
        <Row className="mt-1">
          <Checkbox checked={saveImage} onChange={(e) => setSaveImage(e.target.checked)}>
            イメージを保存する
          </Checkbox>
        </Row>
        <Row className="mt-1">
          <Checkbox checked={calculationOnSave} onChange={(e) => setCalculationOnSave(e.target.checked)}>
            保存時に数量別計算を実行する
          </Checkbox>
        </Row>
        <Row className="mt-1">
          <Checkbox checked={saveWithSameName} onChange={(e) => setSaveWithSameName(e.target.checked)}>
            親図番の同一名の保存を許可する
          </Checkbox>
        </Row>
        <Row className="mt-4">子部品追加の設定</Row>
        <Row className="mt-2">
          <Checkbox checked={addMultiChildParts} onChange={(e) => setAddMultiChildParts(e.target.checked)}>
            子部品追加時に個数を指定して複数同時追加を行う
          </Checkbox>
        </Row>
        <Row className="mt-4">工程選択の設定</Row>
        <Row className="mt-2">
          <Checkbox checked={showConfirmDialogue} onChange={(e) => setShowConfirmDialogue(e.target.checked)}>
            工程選択を行ったときに他の子部品も同じ変更を行うか確認ウィンドウを表示する
          </Checkbox>
        </Row> */}

      {/* <Row className="mt-4">金額表示の設定</Row>
        <Row align="middle" className="mt-2">
          <Col span={2}>見積金額切上げ桁数</Col>
          <Col span={2} style={{ textAlign: 'end' }}>
            <Row>
              <Col span={18}>
                <Input value={companySettingObj?.environments?.roundUpDigits} style={{ width: '60%' }}></Input>
              </Col>
              <Col span={4}>
                <Row>
                  <CaretUpOutlined
                    style={{ color: '#1063aa', fontSize: 16 }}
                    onClick={(e) => increaseEstimatedAmount('estimate')}
                  />
                </Row>
                <Row>
                  <CaretDownOutlined
                    style={{ color: '#1063aa', fontSize: 16 }}
                    onClick={(e) => decreaseEstimatedAmount('estimate')}
                  />
                </Row>
              </Col>
            </Row>
          </Col>

          <Col span={3}>
            <Select
              style={{ fontSize: 11, width: '100%' }}
              value={companySettingObj?.environments?.roundUpMethod}
              onChange={(e) => {
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  environments: {
                    ...prevData?.environments,
                    roundUpMethod: e,
                  },
                }));
              }}
            >
              {Object.entries(RoundUpMethods)?.map(([key, value]) => (
                <Select.Option key={value} value={value}>
                  {key}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
        <Row align="middle" className="mt-2">
          <Col span={2}>小数点以下桁数</Col>
          <Col span={2} style={{ textAlign: 'end' }}>
            <Row>
              <Col span={18}>
                <Input value={companySettingObj?.environments?.decimalPlaces} style={{ width: '60%' }}></Input>
              </Col>
              <Col span={4}>
                <Row>
                  <CaretUpOutlined
                    style={{ color: '#1063aa', fontSize: 16 }}
                    onClick={(e) => increaseEstimatedAmount('decimal')}
                  />
                </Row>
                <Row>
                  <CaretDownOutlined
                    style={{ color: '#1063aa', fontSize: 16 }}
                    onClick={(e) => decreaseEstimatedAmount('decimal')}
                  />
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-2" align="middle">
          <Col span={2}>通貨記号</Col>
          <Col span={5}>
            <Select
              style={{ fontSize: 11, width: '88%', marginLeft: '2.5rem' }}
              value={companySettingObj?.environments?.currencySymbol}
              onChange={(e) => {
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  environments: {
                    ...prevData?.environments,
                    currencySymbol: e,
                  },
                }));
              }}
            >
              {Object.entries(CurrencySymbols)?.map(([key, value]) => (
                <Select.Option key={value} value={value}>
                  {curSymbol[value]}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row> */}
      <div style={{ marginLeft: '1.5rem' }} className="settingContent">
        <Row className="mt-1">
          <Checkbox
            style={{ alignSelf: 'center' }}
            checked={isUseSameName}
            onChange={(e) => {
              if (companySettingObj?.environments) {
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  environments: { ...prevData.environments, isUseSameName: e.target.checked },
                }));
              }
              setIsUseSameName(e.target.checked);
            }}
          >
            同一名の保存を許可する
          </Checkbox>
          <Select
            style={{ fontSize: 11, width: '10%', marginLeft: '1rem' }}
            value={saveSameType}
            onChange={(e) => {
              setCompanySettingObj((prevData) => ({
                ...prevData,
                environments: {
                  ...prevData?.environments,
                  saveSameType: e,
                },
              }));
              setSaveSameType(e);
            }}
          >
            {saveSameTypes?.map((item) => (
              <Select.Option key={item.value} value={item.value}>
                {item.label}
              </Select.Option>
            ))}
          </Select>
        </Row>
      </div>
      <Row className="mt-4">
        <label style={{ fontWeight: 800, fontSize: '13.5px' }}>内径含むの設定</label>
      </Row>
      <div style={{ marginLeft: '1.5rem' }} className="settingContent">
        <Row className="mt-1">
          <Checkbox
            style={{ alignSelf: 'center' }}
            checked={isInnerDiameterIncluded}
            onChange={(e) => {
              if (companySettingObj?.environments) {
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  environments: { ...prevData.environments, isInnerDiameterIncluded: e.target.checked },
                }));
              }
              setIsInnerDiameterIncluded(e.target.checked);
            }}
          >
            内径含む
          </Checkbox>
        </Row>
      </div>

      <Row className="mt-4">
        {/* <label style={{ fontWeight: 800, fontSize: '13.5px' }}>複数子部品追加登録</label> */}
      </Row>

      {/* 2025-08-04 IQX_WEBEST-439 機能追加の要望①「下敕き図面保存」 */}
      <Row className="mt-1">
        <Checkbox
          style={{ alignSelf: 'center' }}
          checked={isSaveDrawing}
          onChange={(e) => {
            if (companySettingObj?.environments) {
              setCompanySettingObj((prevData) => ({
                ...prevData,
                environments: { ...prevData.environments, isSaveDrawing: e.target.checked },
              }));
            }
            setIsSaveDrawing(e.target.checked);
          }}
        >
          下敕き図面保存
        </Checkbox>
      </Row>

      {/* 2025-07-23 IQX_WEBEST-439 機能追加の要望①「空送線計算有」 */}
      <Row className="mt-1">
        <Checkbox
          style={{ alignSelf: 'center' }}
          checked={isAirLineCalculation}
          onChange={(e) => {
            if (companySettingObj?.environments) {
              setCompanySettingObj((prevData) => ({
                ...prevData,
                environments: { ...prevData.environments, isAirLineCalculation: e.target.checked },
              }));
            }
            setIsAirLineCalculation(e.target.checked);
          }}
        >
          空送線計算有
        </Checkbox>
      </Row>

      {/* 2025-07-23 IQX_WEBEST-440 機能追加の要望②「外形線1本化処理計算」 */}
      <Row className="mt-1">
        <Checkbox
          style={{ alignSelf: 'center' }}
          checked={isSingleOutlineProcessingCalculation}
          onChange={(e) => {
            if (companySettingObj?.environments) {
              setCompanySettingObj((prevData) => ({
                ...prevData,
                environments: { ...prevData.environments, isSingleOutlineProcessingCalculation: e.target.checked },
              }));
            }
            setIsSingleOutlineProcessingCalculation(e.target.checked);
          }}
        >
          外形線1本化処理計算
        </Checkbox>
      </Row>

      {/* 2025-07-23 IQX_WEBEST-441 機能追加の要望③「同一線上曲げ線をまとめる」 */}
      <Row className="mt-1">
        <Checkbox
          style={{ alignSelf: 'center' }}
          checked={isCollinearBendingLine}
          onChange={(e) => {
            if (companySettingObj?.environments) {
              setCompanySettingObj((prevData) => ({
                ...prevData,
                environments: { ...prevData.environments, isCollinearBendingLine: e.target.checked },
              }));
            }
            setIsCollinearBendingLine(e.target.checked);
          }}
        >
          同一線上曲げ線をまとめる
        </Checkbox>
      </Row>

      {/* 2025-07-23 IQX_WEBEST-442 機能追加の要望④「ブランク加工下穴計算有」 */}
      <Row className="mt-1">
        <Checkbox
          style={{ alignSelf: 'center' }}
          checked={isBlankDrillingCalculation}
          onChange={(e) => {
            if (companySettingObj?.environments) {
              setCompanySettingObj((prevData) => ({
                ...prevData,
                environments: { ...prevData.environments, isBlankDrillingCalculation: e.target.checked },
              }));
            }
            setIsBlankDrillingCalculation(e.target.checked);
          }}
        >
          ブランク加工下穴計算有
        </Checkbox>
      </Row>

      {/* 2025-07-22 IQX_WEBEST-443 機能追加の要望⑤「複数子部品追加登録」 */}
      <Row className="mt-1">
        <Checkbox
          style={{ alignSelf: 'center' }}
          checked={isAddMultipleChildParts}
          onChange={(e) => {
            if (companySettingObj?.environments) {
              setCompanySettingObj((prevData) => ({
                ...prevData,
                environments: { ...prevData.environments, isAddMultipleChildParts: e.target.checked },
              }));
            }
            setIsAddMultipleChildParts(e.target.checked);
          }}
        >
          複数子部品追加登録
        </Checkbox>
      </Row>
      {/* </div> */}
      <Row style={{ marginTop: '4rem' }}>
        <Col span={7} style={{ textAlign: 'right' }}>
          <Button
            className="mainButton"
            onClick={() => {
              setSaveConfirm(userSettingInfo?.massages?.editOk);
              if (!userSettingInfo?.massages?.editOk) {
                updConfirmOk();
              }
            }}
          >
            保存
          </Button>
        </Col>
      </Row>
    </>
  );
  const exportSetting = (
    <>
      <Row className="mt-4">
        <label style={{ fontWeight: 800, fontSize: '13.5px' }}>出力フォーマットの設定</label>
      </Row>
      <div style={{ marginLeft: '1.5rem' }} className="settingContent">
        <Row className="mt-2">
          <label>Excelフォーマット管理</label>
        </Row>
        <div
          className="col-md-10"
          onDragEnter={handleDragEnter}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          style={{ border: `1px dashed ${dragging ? 'blue' : 'black'}`, padding: '20px', marginTop: '0.5em' }}
        >
          <Row justify="center" align="middle">
            <label>ファイルをドラック＆ドロップかクリックでアップロード　または　</label>{' '}
            <input
              type="file"
              accept=".xlsx"
              ref={excelFileRef}
              style={{ display: 'none' }}
              onChange={handleExcelFileChange}
              onClick={(e) => (e.target.value = null)}
            />
            <Button onClick={browseExcelFiles} style={{ backgroundColor: '#005fab', color: 'white' }}>
              ファイルを選択
            </Button>
            {/** IQX_WEBEST-273 帳票のExcelをダウンロードしたい IQX_WEBEST-274 帳票のExcelを削除したい */}
            <Button
              onClick={openDownloadFileModal}
              style={{ marginLeft: 30, backgroundColor: '#005fab', color: 'white' }}
            >
              ファイル一覧表示
            </Button>
          </Row>
        </div>
        {/*  <div className="overflow-auto" style={{ height: '100px' }}>
          {files?.length > 0 ? (
            <>
              <Row>
                <ul>
                  {files?.map((file, index) => (
                    <li key={index}>{file.name}</li>
                  ))}
                </ul>
              </Row>
              <Row justify="center">
                <Col span={11}>
                  <Button
                    className="mainButton"
                    onClick={() => {
                      handleFileUpload();
                    }}
                  >
                    保存
                  </Button>
                </Col>
              </Row>
            </>
          ) : excelFiles?.length > 0 ? (
            <>
              <Row></Row>
              <Row justify="center">
                <Col span={11}>
                  <Button
                    className="mainButton"
                    onClick={() => {
                      handleFileUpload();
                    }}
                  >
                    保存
                  </Button>
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}
        </div> */}
        <div
          className="registerModal mt-4 chargeAmount overflow-auto"
          style={{ height: 245, overflowY: 'scroll', width: '66%' }}
        >
          <Table>
            <thead>
              <tr style={{ height: '42px', verticalAlign: 'middle' }}>
                <td className="tbl-header fixedHeader" style={{ width: '15%' }}>
                  タイトル
                </td>
                <td className="tbl-header fixedHeader" style={{ width: '15%' }}>
                  利用シーン
                </td>
                <td className="tbl-header fixedHeader" style={{ width: '15%' }}>
                  ファイル名
                </td>
                {/*  <td className="tbl-header fixedHeader" style={{ width: '15%' }}></td> */}
                <td style={{ border: 'none', backgroundColor: 'white' }} className="fixedHeader"></td>
              </tr>
            </thead>
            <tbody>
              {excelFilesList?.map((item, index) => (
                <tr key={index} style={{ textAlign: 'center', verticalAlign: 'middle', height: '40px' }}>
                  <td>
                    <Input
                      value={item.title}
                      onChange={(e) => {
                        setExcelFilesList((prevData) => {
                          const newData = [...prevData];
                          newData[index] = {
                            ...newData[index],
                            title: e.target.value,
                            fileId: e.target.value,
                          };
                          return newData;
                        });
                      }}
                    ></Input>
                  </td>
                  <td>
                    <Select
                      style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
                      value={item.useType}
                      onChange={(e) => {
                        setExcelFilesList((prevData) => {
                          const newData = [...prevData];
                          newData[index] = {
                            ...newData[index],
                            useType: e,
                          };
                          return newData;
                        });
                      }}
                    >
                      {Object.entries(PrintTypes)?.map(([key, value]) => (
                        <Select.Option key={value} value={value}>
                          {riyoushin[value]}
                        </Select.Option>
                      ))}
                    </Select>
                  </td>
                  <td>
                    <Select
                      style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
                      value={item.fileName}
                      onChange={(e) => {
                        setExcelFilesList((prevData) => {
                          const newData = [...prevData];
                          newData[index] = {
                            ...newData[index],
                            fileName: e,
                            fileId: e,
                          };
                          return newData;
                        });
                      }}
                    >
                      {uploadedFileLst?.map((item, index) => (
                        <Select.Option key={index} value={item.value}>
                          {item.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </td>
                  {/* <td>{item.note}</td> */}
                  <td style={{ border: 'none', backgroundColor: 'white', verticalAlign: 'middle', width: '6%' }}>
                    <Row justify="center">
                      <PlusCircleFilled
                        className="add-remove-icon"
                        style={{ marginLeft: 5, marginRight: 5 }}
                        onClick={(e) => handleIncrease(e, index, 'excel')}
                      />
                      <CloseCircleFilled
                        className="add-remove-icon"
                        onClick={(e) => handleDecrease(e, index, 'excel')}
                      />
                    </Row>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        {/* <Row className="mt-4">
          <label>CSVフォーマット管理</label>
        </Row>
        <div
          className="registerModal mt-2 chargeAmount overflow-auto"
          style={{ height: 245, overflowY: 'scroll', width: '66%' }}
        >
          <Table>
            <thead>
              <tr style={{ height: '42px', verticalAlign: 'middle' }}>
                <td className="tbl-header fixedHeader" style={{ width: '15%' }}>
                  タイトル
                </td>
                <td className="tbl-header fixedHeader" style={{ width: '15%' }}>
                  利用シーン
                </td>
                <td className="tbl-header fixedHeader" style={{ width: '30%' }}>
                  出力例
                </td>
                <td style={{ border: 'none', backgroundColor: 'white' }} className="fixedHeader"></td>
              </tr>
            </thead>
            <tbody>
              {csvFilesList?.map((item, index) => (
                <tr style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                  <td>
                    <Input value={item.title}></Input>
                  </td>
                  <td>
                    <Select style={{ fontSize: 11, width: '100%', textAlign: 'left' }} value={item.useFor}>
                      {outputOptions?.map((item) => (
                        <Select.Option value={item.value}>{item.label}</Select.Option>
                      ))}
                    </Select>
                  </td>
                  <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>
                    <Row>
                      <Col span={22}>{item.examples}</Col>
                      <Col span={2}>
                        <EditOutlined
                          style={{ color: '#1063aa', fontSize: 20, stroke: 'white' }}
                          onClick={editCSVSetting}
                        />
                      </Col>
                    </Row>
                  </td>
                  <td style={{ border: 'none', backgroundColor: 'white', verticalAlign: 'middle', width: '6%' }}>
                    <Row justify="center">
                      <PlusCircleFilled
                        className="add-remove-icon"
                        style={{ marginLeft: 5, marginRight: 5 }}
                        onClick={(e) => handleIncrease(e, item.key, 'csv')}
                      />
                      <CloseCircleFilled
                        className="add-remove-icon"
                        onClick={(e) => handleDecrease(e, item.key, 'csv')}
                      />
                    </Row>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div> */}
        <Row style={{ marginTop: '4rem' }}>
          <Col span={8} style={{ textAlign: 'right' }}>
            <Button
              className={uploadedFileLst[0] == undefined || uploadedFileLst[0]?.length == 0 ? '' : 'mainButton'}
              onClick={() => {
                setSaveConfirm(userSettingInfo?.massages?.editOk);
                if (!userSettingInfo?.massages?.editOk) {
                  updConfirmOk();
                }
              }}
              disabled={uploadedFileLst[0] == undefined || uploadedFileLst[0]?.length == 0}
            >
              保存
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
  const reportSetting = (
    <>
      <Row className="mt-4">
        <label style={{ fontWeight: 800, fontSize: '13.5px' }}>帳票の設定</label>
      </Row>
      <div style={{ marginLeft: '1.5rem' }} className="settingContent">
        <Row className="mt-2">個別帳票</Row>
        <Row className="mt-1">
          <Checkbox
            checked={individualExcelQuickOutput}
            onChange={(e) => {
              if (companySettingObj?.printOutputs?.length > 0) {
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  printOutputs: prevData?.printOutputs?.map((output, index) => {
                    if (output.printType === PrintTypes.individual) {
                      return {
                        ...output,
                        isUseQuickOutput: e.target.checked,
                      };
                    }
                    return output;
                  }),
                }));
              }
              setIndividualExcelQuickOutput(e.target.checked);
            }}
          >
            Quick出力を有効にする
          </Checkbox>
        </Row>
        {/* <Row>
          <Checkbox
            checked={individualAutoExcelExport}
            onChange={(e) => setIndividualAutoExcelExport(e.target.checked)}
          >
            帳票出力後、Excelファイルを自動で開く
          </Checkbox>
        </Row> */}
        {/* <Row className="mt-4">
          <label>出力フォルダ</label>
        </Row>
        <Row align="middle">
          <Col span={6}>
            <Input value={fileName}></Input>
          </Col>
          <Col span={1}>
            <input
              type="file"
              ref={reportOutputFolderRef}
              style={{ display: 'none' }}
              onChange={handleWorkFileChange}
            />
            <Button className="referenceButton" onClick={browseIndividualFile} style={{ marginLeft: 3 }}>
              参照
            </Button>
          </Col>
        </Row> */}
        <Row className="mt-4">
          <label>出力ファイル</label>
        </Row>
        <Row>
          <Col span={6}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={individualFormatId}
              onChange={(e) => {
                if (companySettingObj?.printOutputs?.length > 0) {
                  setCompanySettingObj((prevData) => ({
                    ...prevData,
                    printOutputs: prevData?.printOutputs?.map((output, index) => {
                      if (output.printType === PrintTypes.individual) {
                        // Update the second object while leaving others unchanged
                        return {
                          ...output,
                          formatsId: e,
                        };
                      }
                      return output; // Leave other objects unchanged
                    }),
                  }));
                }
                setIndividualFormatId(e);
              }}
            >
              {excelFilesList[0]?.id !== 0 ? (
                excelFilesList?.map((item) => {
                  if (item.useType === 0) {
                    return (
                      <Select.Option key={item.id} value={item.id}>
                        {item?.fileName}
                      </Select.Option>
                    );
                  }
                  return null; // Return null for items that don't meet the condition
                })
              ) : (
                <Select.Option></Select.Option>
              )}
            </Select>
          </Col>
        </Row>
        {/* list  */}
        <Row style={{ marginTop: '2.5rem' }}>リスト帳票</Row>
        <Row className="mt-1">
          <Checkbox
            checked={listExcelQuickOutput}
            onChange={(e) => {
              if (companySettingObj?.printOutputs?.length > 0) {
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  printOutputs: prevData?.printOutputs?.map((output, index) => {
                    if (output.printType === PrintTypes.list) {
                      return {
                        ...output,
                        isUseQuickOutput: e.target.checked,
                      };
                    }
                    return output;
                  }),
                }));
              }
              setListExcelQuickOutput(e.target.checked);
            }}
          >
            Quick出力を有効にする
          </Checkbox>
        </Row>
        {/* <Row>
          <Checkbox checked={listAutoExcelExport} onChange={(e) => setListAutoExcelExport(e.target.checked)}>
            帳票出力後、Excelファイルを自動で開く
          </Checkbox>
        </Row> */}
        {/* <Row className="mt-4">
          <label>出力フォルダ</label>
        </Row>
        <Row align="middle">
          <Col span={6}>
            <Input value={fileName}></Input>
          </Col>
          <Col span={1}>
            <input
              type="file"
              ref={reportOutputFolderRef}
              style={{ display: 'none' }}
              onChange={handleWorkFileChange}
            />
            <Button className="referenceButton" onClick={browseIndividualFile} style={{ marginLeft: 3 }}>
              参照
            </Button>
          </Col>
        </Row> */}
        <Row className="mt-4">
          <label>出力ファイル</label>
        </Row>
        <Row>
          <Col span={6}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              // value={excelFilesList[0]?.id != 0 ? listFormatId : ''}
              value={listFormatId}
              onChange={(e) => {
                if (companySettingObj?.printOutputs?.length > 0) {
                  setCompanySettingObj((prevData) => ({
                    ...prevData,
                    printOutputs: prevData?.printOutputs?.map((output, index) => {
                      if (output.printType === PrintTypes.list) {
                        // Update the second object while leaving others unchanged
                        return {
                          ...output,
                          formatsId: e,
                        };
                      }
                      return output;
                    }),
                  }));
                }
                setListFormatId(e);
              }}
            >
              {excelFilesList[0]?.id !== 0 ? (
                excelFilesList?.map((item) => {
                  if (item?.useType === 1) {
                    return (
                      <Select.Option key={item.id} value={item.id}>
                        {item?.fileName}
                      </Select.Option>
                    );
                  }
                  return null; // Return null for items that don't meet the condition
                })
              ) : (
                <Select.Option></Select.Option>
              )}
              {/* {formatLst != [] || formatLst != undefined ? (
                formatLst?.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item?.fileName}
                  </Select.Option>
                ))
              ) : (
                
              )} */}
            </Select>
          </Col>
        </Row>
        <Row style={{ marginTop: '4rem' }}>
          <Col span={6} style={{ textAlign: 'right' }}>
            <Button
              className={excelFilesList[0]?.id == 0 ? '' : 'mainButton'}
              onClick={() => {
                setSaveConfirm(true);
              }}
              disabled={excelFilesList[0]?.id == 0}
            >
              保存
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
  const csvExportSetting = (
    <>
      <Row className="mt-4">
        <label style={{ fontWeight: 800, fontSize: '13.5px' }}>CSV出力の設定</label>
      </Row>
      <div style={{ marginLeft: '1.5rem' }} className="settingContent">
        <Row className="mt-2">個別帳票</Row>
        <Row className="mt-1">
          <Checkbox checked={individualCSVQuickOutput} onChange={(e) => setIndividualCSVQuickOutput(e.target.checked)}>
            Quick出力を有効にする
          </Checkbox>
        </Row>
        {/* <Row className="mt-1">
          <Checkbox checked={individualAutoCSVExport} onChange={(e) => setIndividualAutoCSVExport(e.target.checked)}>
            帳票出力後、CSVファイルを自動で開く
          </Checkbox>
        </Row>
        <Row className="mt-4">
          <label>出力フォルダ</label>
        </Row>
        <Row align="middle">
          <Col span={6}>
            <Input value={fileName}></Input>
          </Col>
          <Col span={1}>
            <input
              type="file"
              ref={reportOutputFolderRef}
              style={{ display: 'none' }}
              onChange={handleWorkFileChange}
            />
            <Button className="referenceButton" onClick={browseIndividualFile} style={{ marginLeft: 3 }}>
              参照
            </Button>
          </Col>
        </Row> */}
        <Row className="mt-4">
          <label>出力形式</label>
        </Row>
        <Row>
          <Col span={6}>
            <Select style={{ width: '100%' }} value={1}>
              <Select.Option value={1}>生産管理連携_最新</Select.Option>
            </Select>
          </Col>
        </Row>
        {/* list  */}
        <Row style={{ marginTop: '2.5rem' }}>リスト帳票</Row>
        <Row className="mt-1">
          <Checkbox checked={listCSVQuickOutput} onChange={(e) => setListCSVQuickOutput(e.target.checked)}>
            Quick出力を有効にする
          </Checkbox>
        </Row>
        {/* <Row className="mt-1">
          <Checkbox checked={listAutoCSVExport} onChange={(e) => setListAutoCSVExport(e.target.checked)}>
            帳票出力後、CSVファイルを自動で開く
          </Checkbox>
        </Row>
        <Row className="mt-4">
          <label>出力フォルダ</label>
        </Row>
        <Row align="middle">
          <Col span={6}>
            <Input value={fileName}></Input>
          </Col>
          <Col span={1}>
            <input
              type="file"
              ref={reportOutputFolderRef}
              style={{ display: 'none' }}
              onChange={handleWorkFileChange}
            />
            <Button className="referenceButton" onClick={browseIndividualFile} style={{ marginLeft: 3 }}>
              参照
            </Button>
          </Col>
        </Row> */}
        <Row className="mt-4">
          <label>出力ファイル</label>
        </Row>
        <Row>
          <Col span={6}>
            <Select style={{ width: '100%' }} value={1}>
              <Select.Option value={1}>親備品リス</Select.Option>
            </Select>
          </Col>
        </Row>
        <Row style={{ marginTop: '4rem' }}>
          <Col span={6} style={{ textAlign: 'right' }}>
            <Button className="mainButton">保存</Button>
          </Col>
        </Row>
      </div>
    </>
  );

  const defaultNameSetting = (
    <>
      <Row className="mt-4">
        <label style={{ fontWeight: 800, fontSize: '13.5px' }}>親部品の初期名称の設定</label>
      </Row>
      <div style={{ marginLeft: '1.5rem' }} className="settingContent">
        {/** 図番 */}
        <Row className="mt-2">
          <label>図番</label>
        </Row>
        <Row className="mt-1">
          <Col span={2}>
            <Input
              name="input1"
              value={parentDrawingNo?.input1}
              onChange={(e) => {
                const data = { ...parentDrawingNo };
                data.input1 = e.target.value;
                setParentDrawingNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[0] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5 }}
              className="input-editable"
            />
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Input
              name="input2"
              value={parentDrawingNo?.input2}
              onChange={(e) => {
                const data = { ...parentDrawingNo };
                data.input2 = e.target.value;
                setParentDrawingNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[0] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5, width: '70%', textAlign: 'center' }}
              className="input-editable"
            />
          </Col>
          <Col span={2}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={parentDrawingNo?.select1}
              onChange={(e) => {
                const data = { ...parentDrawingNo };
                data.select1 = e;
                setParentDrawingNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[0] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
            >
              {parentnamingConditions?.map((item, index) => (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Input
              name="input3"
              value={parentDrawingNo?.input3}
              onChange={(e) => {
                const data = { ...parentDrawingNo };
                data.input3 = e.target.value;
                setParentDrawingNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[0] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5, textAlign: 'center', width: '70%' }}
              className="input-editable"
            />
          </Col>
          <Col span={2}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={parentDrawingNo?.select2}
              onChange={(e) => {
                const data = { ...parentDrawingNo };
                data.select2 = e;
                setParentDrawingNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[0] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
            >
              {parentnamingConditions?.map((item, index) => (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Input
              name="input4"
              value={parentDrawingNo?.input4}
              onChange={(e) => {
                const data = { ...parentDrawingNo };
                data.input4 = e.target.value;
                setParentDrawingNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[0] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5, textAlign: 'center', width: '70%' }}
              className="input-editable"
            />
          </Col>
          <Col span={2}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={parentDrawingNo?.select3}
              onChange={(e) => {
                const data = { ...parentDrawingNo };
                data.select3 = e;
                setParentDrawingNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[0] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
            >
              {parentnamingConditions?.map((item, index) => (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
        {/** 名称 */}
        <Row className="mt-2">
          <label>名称</label>
        </Row>
        <Row className="mt-1">
          <Col span={2}>
            <Input
              name="input1"
              value={parentName?.input1}
              onChange={(e) => {
                const data = { ...parentName };
                data.input1 = e.target.value;
                setParentName(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[1] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5 }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Input
              name="input2"
              value={parentName?.input2}
              onChange={(e) => {
                const data = { ...parentName };
                data.input2 = e.target.value;
                setParentName(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[1] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5, textAlign: 'center', width: '70%' }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={2}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={parentName?.select1}
              onChange={(e) => {
                const data = { ...parentName };
                data.select1 = e;
                setParentName(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[1] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
            >
              {parentnamingConditions?.map((item, index) => (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Input
              name="input3"
              value={parentName?.input3}
              onChange={(e) => {
                const data = { ...parentName };
                data.input3 = e.target.value;
                setParentName(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[1] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5, textAlign: 'center', width: '70%' }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={2}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={parentName?.select2}
              onChange={(e) => {
                const data = { ...parentName };
                data.select2 = e;
                setParentName(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[1] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
            >
              {parentnamingConditions?.map((item, index) => (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Input
              name="input4"
              value={parentName?.input4}
              onChange={(e) => {
                const data = { ...parentName };
                data.input4 = e.target.value;
                setParentName(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[1] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5, textAlign: 'center', width: '70%' }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={2}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={parentName?.select3}
              onChange={(e) => {
                const data = { ...parentName };
                data.select3 = e;
                setParentName(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[1] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
            >
              {parentnamingConditions?.map((item, index) => (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
        {/** 見積番号 */}
        <Row className="mt-2">
          <label>見積番号</label>
        </Row>
        <Row className="mt-1">
          <Col span={2}>
            <Input
              name="input1"
              value={parentEstimateNo?.input1}
              onChange={(e) => {
                const data = { ...parentEstimateNo };
                data.input1 = e.target.value;
                setParentEstimateNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[2] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5 }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Input
              name="input2"
              value={parentEstimateNo?.input2}
              onChange={(e) => {
                const data = { ...parentEstimateNo };
                data.input2 = e.target.value;
                setParentEstimateNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[2] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5, textAlign: 'center', width: '70%' }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={2}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={parentEstimateNo?.select1}
              onChange={(e) => {
                const data = { ...parentEstimateNo };
                data.select1 = e;
                setParentEstimateNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[2] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
            >
              {parentnamingConditions?.map((item, index) => (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Input
              name="input3"
              value={parentEstimateNo?.input3}
              onChange={(e) => {
                const data = { ...parentEstimateNo };
                data.input3 = e.target.value;
                setParentEstimateNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[2] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5, textAlign: 'center', width: '70%' }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={2}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={parentEstimateNo?.select2}
              onChange={(e) => {
                const data = { ...parentEstimateNo };
                data.select2 = e;
                setParentEstimateNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[2] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
            >
              {parentnamingConditions?.map((item, index) => (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Input
              name="input4"
              value={parentEstimateNo?.input4}
              onChange={(e) => {
                const data = { ...parentEstimateNo };
                data.input4 = e.target.value;
                setParentEstimateNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[2] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5, textAlign: 'center', width: '70%' }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={2}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={parentEstimateNo?.select3}
              onChange={(e) => {
                const data = { ...parentEstimateNo };
                data.select3 = e;
                setParentEstimateNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.parentInitNameInfo[2] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
            >
              {parentnamingConditions?.map((item, index) => (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
      </div>

      <Row style={{ marginTop: '2.5rem' }}>
        <label style={{ fontWeight: 800, fontSize: '13.5px' }}>子部品の初期名称の設定</label>
      </Row>
      <div style={{ marginLeft: '1.5rem' }} className="settingContent">
        {/** 図番 */}
        <Row className="mt-2">
          <label>図番</label>
        </Row>
        <Row className="mt-1">
          <Col span={2}>
            <Input
              name="input1"
              value={childDrawingNo?.input1}
              onChange={(e) => {
                const data = { ...childDrawingNo };
                data.input1 = e.target.value;
                setChildDrawingNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.childInitNameInfo[0] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5 }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Input
              name="input2"
              value={childDrawingNo?.input2}
              onChange={(e) => {
                const data = { ...childDrawingNo };
                data.input2 = e.target.value;
                setChildDrawingNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.childInitNameInfo[0] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5, textAlign: 'center', width: '70%' }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={2}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={childDrawingNo?.select1}
              onChange={(e) => {
                const data = { ...childDrawingNo };
                data.select1 = e;
                setChildDrawingNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.childInitNameInfo[0] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
            >
              {namingConditions?.map((item, index) => (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Input
              name="input3"
              value={childDrawingNo?.input3}
              onChange={(e) => {
                const data = { ...childDrawingNo };
                data.input3 = e.target.value;
                setChildDrawingNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.childInitNameInfo[0] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5, textAlign: 'center', width: '70%' }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={2}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={childDrawingNo?.select2}
              onChange={(e) => {
                const data = { ...childDrawingNo };
                data.select2 = e;
                setChildDrawingNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.childInitNameInfo[0] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
            >
              {namingConditions?.map((item, index) => (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Input
              name="input4"
              value={childDrawingNo?.input4}
              onChange={(e) => {
                const data = { ...childDrawingNo };
                data.input4 = e.target.value;
                setChildDrawingNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.childInitNameInfo[0] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5, textAlign: 'center', width: '70%' }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={2}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={childDrawingNo?.select3}
              onChange={(e) => {
                const data = { ...childDrawingNo };
                data.select3 = e;
                setChildDrawingNo(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.childInitNameInfo[0] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
            >
              {namingConditions?.map((item, index) => (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
        {/** 子部品名称 */}
        <Row className="mt-2">
          <label>子部品名称</label>
        </Row>
        <Row className="mt-1">
          <Col span={2}>
            <Input
              name="input1"
              value={childName?.input1}
              onChange={(e) => {
                const data = { ...childName };
                data.input1 = e.target.value;
                setChildName(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.childInitNameInfo[1] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5 }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Input
              name="input2"
              value={childName?.input2}
              onChange={(e) => {
                const data = { ...childName };
                data.input2 = e.target.value;
                setChildName(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.childInitNameInfo[1] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5, textAlign: 'center', width: '70%' }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={2}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={childName?.select1}
              onChange={(e) => {
                const data = { ...childName };
                data.select1 = e;
                setChildName(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.childInitNameInfo[1] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
            >
              {namingConditions?.map((item, index) => (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Input
              name="input3"
              value={childName?.input3}
              onChange={(e) => {
                const data = { ...childName };
                data.input3 = e.target.value;
                setChildName(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.childInitNameInfo[1] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5, textAlign: 'center', width: '70%' }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={2}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={childName?.select2}
              onChange={(e) => {
                const data = { ...childName };
                data.select2 = e;
                setChildName(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.childInitNameInfo[1] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
            >
              {namingConditions?.map((item, index) => (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={1} style={{ textAlign: 'center' }}>
            <Input
              name="input4"
              value={childName?.input4}
              onChange={(e) => {
                const data = { ...childName };
                data.input4 = e.target.value;
                setChildName(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.childInitNameInfo[1] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
              style={{ padding: 5, textAlign: 'center', width: '70%' }}
              className="input-editable percent-input "
            />
          </Col>
          <Col span={2}>
            <Select
              style={{ fontSize: 11, width: '100%', textAlign: 'left' }}
              value={childName?.select3}
              onChange={(e) => {
                const data = { ...childName };
                data.select3 = e;
                setChildName(data);
                const initNamesCopy = { ...companySettingObj?.initNames };
                initNamesCopy.childInitNameInfo[1] = data;
                setCompanySettingObj((prevData) => ({
                  ...prevData,
                  initNames: initNamesCopy,
                }));
              }}
            >
              {namingConditions?.map((item, index) => (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
      </div>

      <Row style={{ marginTop: '2.5rem' }}>
        <label style={{ fontWeight: 600, fontSize: '13.5px' }}>CADCAMタイブの初期名称設定</label>
      </Row>
      <div style={{ marginTop: '0.5rem', marginLeft: '1.5rem' }} className="settingContent">
        <Select
          style={{ width: 250 }}
          popupMatchSelectWidth={false}
          defaultValue={0}
          id={'dxfTypeCode'}
          name={'dxfTypeCode'}
          value={companySettingObj?.dxfTypeCode > 0 ? companySettingObj?.dxfTypeCode : dxfTypes?.[0].id}
          onChange={(e) => {
            setCompanySettingObj((prevData) => ({
              ...prevData,
              dxfTypeCode: e,
            }));
          }}
        >
          {dxfTypes?.map((item, index) => (
            <Select.Option key={index + 'dxfType'} id={'dxfType' + index} value={item.id}>
              {item.name}
            </Select.Option>
          ))}
        </Select>

        <Row style={{ marginTop: '4rem' }}>
          <Col span={14} style={{ textAlign: 'right' }}>
            <Button
              className="mainButton"
              onClick={() => {
                setSaveConfirm(userSettingInfo?.massages?.editOk);
                if (!userSettingInfo?.massages?.editOk) {
                  updConfirmOk();
                }
              }}
            >
              保存
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );

  const dxfOptionSetting = (
    <div style={{ padding: 0 }}>
      <div className="user-setting-div" style={{ height: '87vh' }}>
        {/** 丸穴認識最大径 */}
        <Row style={{ paddingLeft: 3, paddingBottom: 3, marginLeft: 15 }}>
          <Col span={2}>丸穴認識最大径</Col>
          <Col span={22}>
            <div style={{ display: 'flex' }}>
              <Input
                className="input-editable"
                value={companySettingObj?.dxfOptionsSetting?.MaxDiameterForHoleIdentification}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    const dxfOptions = companySettingObj?.dxfOptionsSetting;
                    dxfOptions.MaxDiameterForHoleIdentification = value;
                    setCompanySettingObj((prevData) => ({
                      ...prevData,
                      dxfOptionsSetting: dxfOptions,
                    }));
                  }
                }}
                onBlur={(e) => {
                  let value = Number(companySettingObj?.dxfOptionsSetting.MaxDiameterForHoleIdentification) || 0;
                  if (value < 1) value = 0;
                  const dxfOptions = companySettingObj?.dxfOptionsSetting;
                  dxfOptions.MaxDiameterForHoleIdentification = value;
                  setCompanySettingObj((prevData) => ({
                    ...prevData,
                    dxfOptionsSetting: dxfOptions,
                  }));
                }}
                style={{ height: 28, width: '80px' }}
              ></Input>

              <Checkbox
                style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                key="convertPointToPierce"
                type="checkbox"
                name={'convertPointToPierce'}
                id={'convertPointToPierce'}
                checked={companySettingObj?.dxfOptionsSetting?.ConvertPointToPierce}
                onChange={(e) => {
                  const value = e.target.checked;
                  const dxfOptions = companySettingObj?.dxfOptionsSetting;
                  dxfOptions.ConvertPointToPierce = value;
                  setCompanySettingObj((prevData) => ({
                    ...prevData,
                    dxfOptionsSetting: dxfOptions,
                  }));
                }}
              >
                <span style={{ margin: 0 }}>点をピアス穴に変換する。</span>
              </Checkbox>
              <Checkbox
                style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                key="breakBSpline"
                type="checkbox"
                name={'breakBSpline'}
                id={'breakBSpline'}
                checked={companySettingObj?.dxfOptionsSetting?.BreakBSpline}
                onChange={(e) => {
                  const value = e.target.checked;
                  const dxfOptions = companySettingObj?.dxfOptionsSetting;
                  dxfOptions.BreakBSpline = value;
                  setCompanySettingObj((prevData) => ({
                    ...prevData,
                    dxfOptionsSetting: dxfOptions,
                  }));
                }}
              >
                <span style={{ margin: 0 }}>スプラインを直線分割する</span>
              </Checkbox>

              <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: '14px', margin: 0 }}>スプライン直線分解数</span>
                <Input
                  value={companySettingObj?.dxfOptionsSetting?.DivisionNumberOfBreakingBSpline}
                  className="input-editable"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      const dxfOptions = companySettingObj?.dxfOptionsSetting;
                      dxfOptions.DivisionNumberOfBreakingBSpline = value;
                      setCompanySettingObj((prevData) => ({
                        ...prevData,
                        dxfOptionsSetting: dxfOptions,
                      }));
                    }
                  }}
                  onBlur={(e) => {
                    let value = Number(companySettingObj?.dxfOptionsSetting.DivisionNumberOfBreakingBSpline) || 0;
                    if (value < 1) value = 0;
                    const dxfOptions = companySettingObj?.dxfOptionsSetting;
                    dxfOptions.DivisionNumberOfBreakingBSpline = value;
                    setCompanySettingObj((prevData) => ({
                      ...prevData,
                      dxfOptionsSetting: dxfOptions,
                    }));
                  }}
                  style={{ height: 28, width: '80px' }}
                />
              </div>
            </div>
          </Col>
        </Row>
        <Row style={{ padding: 3, marginLeft: 15 }}>
          <Col span={24}>
            <div style={{ display: 'flex' }}>
              <Checkbox
                style={{ fontSize: '14px', marginLeft: 0, alignItems: 'center' }}
                key="exportMultiFlatFiles"
                type="checkbox"
                name={'exportMultiFlatFiles'}
                id={'exportMultiFlatFiles'}
                checked={companySettingObj?.dxfOptionsSetting?.ExportMultiFlatFiles}
                onChange={(e) => {
                  const value = e.target.checked;
                  const dxfOptions = companySettingObj?.dxfOptionsSetting;
                  dxfOptions.ExportMultiFlatFiles = value;
                  setCompanySettingObj((prevData) => ({
                    ...prevData,
                    dxfOptionsSetting: dxfOptions,
                  }));
                }}
              >
                <span style={{ margin: 0 }}>複数展開図を個別ファイルに出力する。</span>
              </Checkbox>
              <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: '14px', margin: 0 }}>ファイル番号セパレーター</span>
                <Input
                  value={companySettingObj?.dxfOptionsSetting?.FlatIdSeparator}
                  className="input-editable"
                  onChange={(e) => {
                    const value = e.target.value;
                    const dxfOptions = companySettingObj?.dxfOptionsSetting;
                    dxfOptions.FlatIdSeparator = value;
                    setCompanySettingObj((prevData) => ({
                      ...prevData,
                      dxfOptionsSetting: dxfOptions,
                    }));
                  }}
                  style={{ height: 28, width: '80px' }}
                />
              </div>
            </div>
          </Col>
        </Row>
        {/** CADMAC */}
        <Row style={{ padding: 10, paddingTop: 12 }}>
          <Col span={24}>
            <div className="outer-box">
              <div className="box-title">CADMAC</div>
              <div className="box-content">
                <Row>
                  <Col span={2}>曲げ線レイヤー</Col>
                  <Col span={22}>
                    <div style={{ display: 'flex' }}>
                      <Input
                        className="input-editable"
                        value={companySettingObj?.dxfOptionsSetting?.CADMAC_BendLayer}
                        onChange={(e) => {
                          const value = e.target.value;
                          const dxfOptions = companySettingObj?.dxfOptionsSetting;
                          dxfOptions.CADMAC_BendLayer = value;
                          setCompanySettingObj((prevData) => ({
                            ...prevData,
                            dxfOptionsSetting: dxfOptions,
                          }));
                        }}
                        style={{ height: 28, width: '120px' }}
                      ></Input>

                      <Checkbox
                        style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                        key="cADMAC_EffectiveEtching"
                        type="checkbox"
                        name={'cADMAC_EffectiveEtching'}
                        id={'cADMAC_EffectiveEtching'}
                        checked={companySettingObj?.dxfOptionsSetting?.CADMAC_EffectiveEtching}
                        onChange={(e) => {
                          const value = e.target.checked;
                          const dxfOptions = companySettingObj?.dxfOptionsSetting;
                          dxfOptions.CADMAC_EffectiveEtching = value;
                          setCompanySettingObj((prevData) => ({
                            ...prevData,
                            dxfOptionsSetting: dxfOptions,
                          }));
                        }}
                      >
                        <span style={{ margin: 0 }}>有効</span>
                      </Checkbox>

                      <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: '14px', margin: 0 }}>ケガキ</span>
                        <Input
                          value={companySettingObj?.dxfOptionsSetting?.CADMAC_EtchingLayer}
                          className="input-editable"
                          onChange={(e) => {
                            const value = e.target.value;
                            const dxfOptions = companySettingObj?.dxfOptionsSetting;
                            dxfOptions.CADMAC_EtchingLayer = value;
                            setCompanySettingObj((prevData) => ({
                              ...prevData,
                              dxfOptionsSetting: dxfOptions,
                            }));
                          }}
                          style={{ height: 28, width: '120px' }}
                        />
                      </div>
                      <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: '14px', margin: 0 }}>寸法線</span>
                        <Input
                          value={companySettingObj?.dxfOptionsSetting?.CADMAC_DimensionLayer}
                          className="input-editable"
                          onChange={(e) => {
                            const value = e.target.value;
                            const dxfOptions = companySettingObj?.dxfOptionsSetting;
                            dxfOptions.CADMAC_DimensionLayer = value;
                            setCompanySettingObj((prevData) => ({
                              ...prevData,
                              dxfOptionsSetting: dxfOptions,
                            }));
                          }}
                          style={{ height: 28, width: '120px' }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        {/** METACAM AP100Alpha */}
        <Row style={{ padding: 10, paddingTop: 5 }}>
          <Col span={24}>
            <div className="outer-box">
              <div className="box-title">METACAM AP100Alpha</div>
              <div className="box-content">
                <Row>
                  <Col span={2}>曲げ線レイヤー 谷</Col>
                  <Col span={22}>
                    <div style={{ display: 'flex' }}>
                      <Input
                        className="input-editable"
                        value={companySettingObj?.dxfOptionsSetting?.METACAM_FrontBendLayer}
                        onChange={(e) => {
                          const value = e.target.value;
                          const dxfOptions = companySettingObj?.dxfOptionsSetting;
                          dxfOptions.METACAM_FrontBendLayer = value;
                          setCompanySettingObj((prevData) => ({
                            ...prevData,
                            dxfOptionsSetting: dxfOptions,
                          }));
                        }}
                        style={{ height: 28, width: '120px' }}
                      ></Input>

                      <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: '14px', margin: 0 }}>山</span>
                        <Input
                          value={companySettingObj?.dxfOptionsSetting?.METACAM_BackBendLayer}
                          className="input-editable"
                          onChange={(e) => {
                            const value = e.target.value;
                            const dxfOptions = companySettingObj?.dxfOptionsSetting;
                            dxfOptions.METACAM_BackBendLayer = value;
                            setCompanySettingObj((prevData) => ({
                              ...prevData,
                              dxfOptionsSetting: dxfOptions,
                            }));
                          }}
                          style={{ height: 28, width: '120px', marginLeft: 28 }}
                        />
                      </div>
                      <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: '14px', margin: 0 }}>補助線</span>
                        <Input
                          value={companySettingObj?.dxfOptionsSetting?.METACAM_AuxLayer}
                          className="input-editable"
                          onChange={(e) => {
                            const value = e.target.value;
                            const dxfOptions = companySettingObj?.dxfOptionsSetting;
                            dxfOptions.METACAM_AuxLayer = value;
                            setCompanySettingObj((prevData) => ({
                              ...prevData,
                              dxfOptionsSetting: dxfOptions,
                            }));
                          }}
                          style={{ height: 28, width: '120px', marginLeft: 14 }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row style={{ marginTop: 10 }}>
                  <Col span={2}>　　　　　　　 R</Col>
                  <Col span={22}>
                    <div style={{ display: 'flex' }}>
                      <Input
                        className="input-editable"
                        value={companySettingObj?.dxfOptionsSetting?.METACAM_RBendLayer}
                        onChange={(e) => {
                          const value = e.target.value;
                          const dxfOptions = companySettingObj?.dxfOptionsSetting;
                          dxfOptions.METACAM_RBendLayer = value;
                          setCompanySettingObj((prevData) => ({
                            ...prevData,
                            dxfOptionsSetting: dxfOptions,
                          }));
                        }}
                        style={{ height: 28, width: '120px' }}
                      ></Input>

                      <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: '14px', margin: 0 }}>ケガキ</span>
                        <Input
                          value={companySettingObj?.dxfOptionsSetting?.METACAM_EtchingLayer}
                          className="input-editable"
                          onChange={(e) => {
                            const value = e.target.value;
                            const dxfOptions = companySettingObj?.dxfOptionsSetting;
                            dxfOptions.METACAM_EtchingLayer = value;
                            setCompanySettingObj((prevData) => ({
                              ...prevData,
                              dxfOptionsSetting: dxfOptions,
                            }));
                          }}
                          style={{ height: 28, width: '120px' }}
                        />
                      </div>
                      <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: '14px', margin: 0 }}>スリット</span>
                        <Input
                          value={companySettingObj?.dxfOptionsSetting?.METACAM_SlitLayer}
                          className="input-editable"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.METACAM_SlitLayer = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }
                          }}
                          onBlur={(e) => {
                            let value = Number(companySettingObj?.dxfOptionsSetting.METACAM_SlitLayer) || 0;
                            if (value < 1) value = 0;
                            const dxfOptions = companySettingObj?.dxfOptionsSetting;
                            dxfOptions.METACAM_SlitLayer = value;
                            setCompanySettingObj((prevData) => ({
                              ...prevData,
                              dxfOptionsSetting: dxfOptions,
                            }));
                          }}
                          style={{ height: 28, width: '120px' }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        {/** TAKESOFT */}
        <Row style={{ padding: 10, paddingTop: 5 }}>
          <Col span={24}>
            <div className="outer-box">
              <div className="box-title">TAKESOFT</div>
              <div className="box-content">
                <Row>
                  <Col span={2}>曲げ線レイヤー</Col>
                  <Col span={22}>
                    <div style={{ display: 'flex' }}>
                      <Input
                        className="input-editable"
                        value={companySettingObj?.dxfOptionsSetting?.TAKESOFT_BendLayer}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*$/.test(value)) {
                            // setJellDOptions((prev) => ({ ...prev, TAKESOFT_BendLayer: value }));
                            const dxfOptions = companySettingObj?.dxfOptionsSetting;
                            dxfOptions.TAKESOFT_BendLayer = value;
                            setCompanySettingObj((prevData) => ({
                              ...prevData,
                              dxfOptionsSetting: dxfOptions,
                            }));
                          }
                        }}
                        onBlur={(e) => {
                          let value = Number(companySettingObj?.dxfOptionsSetting.TAKESOFT_BendLayer) || 0;
                          if (value < 1) value = 0;
                          const dxfOptions = companySettingObj?.dxfOptionsSetting;
                          dxfOptions.TAKESOFT_BendLayer = value;
                          setCompanySettingObj((prevData) => ({
                            ...prevData,
                            dxfOptionsSetting: dxfOptions,
                          }));
                        }}
                        style={{ height: 28, width: '220px' }}
                      ></Input>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        {/** SHEETWORKS */}
        <Row style={{ padding: 10, paddingTop: 5 }}>
          <Col span={24}>
            <div className="outer-box">
              <div className="box-title">SHEETWORKS</div>
              <div className="box-content">
                <Row>
                  <Col span={2}>曲げ線レイヤー 谷</Col>
                  <Col span={22}>
                    <div style={{ display: 'flex' }}>
                      <Input
                        className="input-editable"
                        value={companySettingObj?.dxfOptionsSetting?.SHEETWORKS_FrontBendLayer}
                        onChange={(e) => {
                          const value = e.target.value;
                          const dxfOptions = companySettingObj?.dxfOptionsSetting;
                          dxfOptions.SHEETWORKS_FrontBendLayer = value;
                          setCompanySettingObj((prevData) => ({
                            ...prevData,
                            dxfOptionsSetting: dxfOptions,
                          }));
                        }}
                        style={{ height: 28, width: '250px' }}
                      ></Input>

                      <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: '14px', margin: 0 }}>山</span>
                        <Input
                          className="input-editable"
                          value={companySettingObj?.dxfOptionsSetting?.SHEETWORKS_BackBendLayer}
                          onChange={(e) => {
                            const value = e.target.value;
                            const dxfOptions = companySettingObj?.dxfOptionsSetting;
                            dxfOptions.SHEETWORKS_BackBendLayer = value;
                            setCompanySettingObj((prevData) => ({
                              ...prevData,
                              dxfOptionsSetting: dxfOptions,
                            }));
                          }}
                          style={{ height: 28, width: '250px', marginLeft: 84 }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row style={{ marginTop: 10 }}>
                  <Col span={2}>スリットレイヤー</Col>
                  <Col span={22}>
                    <div style={{ display: 'flex' }}>
                      <Input
                        className="input-editable"
                        value={companySettingObj?.dxfOptionsSetting?.SHEETWORKS_SlitLayer}
                        onChange={(e) => {
                          const value = e.target.value;
                          const dxfOptions = companySettingObj?.dxfOptionsSetting;
                          dxfOptions.SHEETWORKS_SlitLayer = value;
                          setCompanySettingObj((prevData) => ({
                            ...prevData,
                            dxfOptionsSetting: dxfOptions,
                          }));
                        }}
                        style={{ height: 28, width: '250px' }}
                      ></Input>

                      <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: '14px', margin: 0 }}>ケガキレイヤー</span>
                        <Input
                          value={companySettingObj?.dxfOptionsSetting?.SHEETWORKS_MarkingLayer}
                          className="input-editable"
                          onChange={(e) => {
                            const value = e.target.value;
                            const dxfOptions = companySettingObj?.dxfOptionsSetting;
                            dxfOptions.SHEETWORKS_MarkingLayer = value;
                            setCompanySettingObj((prevData) => ({
                              ...prevData,
                              dxfOptionsSetting: dxfOptions,
                            }));
                          }}
                          style={{ height: 28, width: '250px' }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        {/** G5 */}
        <Row style={{ padding: 10, paddingTop: 5 }}>
          <Col span={24}>
            <div className="outer-box">
              <div className="box-title">G5</div>
              <div className="box-content">
                <Row>
                  <Col span={2}>展開図レイヤー</Col>
                  <Col span={22}>
                    <div style={{ display: 'flex' }}>
                      <Input
                        className="input-editable"
                        value={companySettingObj?.dxfOptionsSetting?.G5_FlatLayer}
                        onChange={(e) => {
                          const value = e.target.value;
                          const dxfOptions = companySettingObj?.dxfOptionsSetting;
                          dxfOptions.G5_FlatLayer = value;
                          setCompanySettingObj((prevData) => ({
                            ...prevData,
                            dxfOptionsSetting: dxfOptions,
                          }));
                        }}
                        style={{ height: 28, width: '120px' }}
                      ></Input>

                      <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: '14px', margin: 0 }}>ケガキ</span>
                        <Input
                          className="input-editable"
                          value={companySettingObj?.dxfOptionsSetting?.G5_EtchingLayer}
                          onChange={(e) => {
                            const value = e.target.value;
                            const dxfOptions = companySettingObj?.dxfOptionsSetting;
                            dxfOptions.G5_EtchingLayer = value;
                            setCompanySettingObj((prevData) => ({
                              ...prevData,
                              dxfOptionsSetting: dxfOptions,
                            }));
                          }}
                          style={{ height: 28, width: '120px', marginLeft: 70 }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row style={{ marginTop: 10 }}>
                  <Col span={2}>曲げ線レイヤー</Col>
                  <Col span={22}>
                    <div style={{ display: 'flex' }}>
                      <Input
                        className="input-editable"
                        value={companySettingObj?.dxfOptionsSetting?.G5_BendLayer}
                        onChange={(e) => {
                          const value = e.target.value;
                          const dxfOptions = companySettingObj?.dxfOptionsSetting;
                          dxfOptions.G5_BendLayer = value;
                          setCompanySettingObj((prevData) => ({
                            ...prevData,
                            dxfOptionsSetting: dxfOptions,
                          }));
                        }}
                        style={{ height: 28, width: '120px' }}
                      ></Input>

                      <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: '14px', margin: 0 }}>曲げ方向レイヤー</span>
                        <Input
                          className="input-editable"
                          value={companySettingObj?.dxfOptionsSetting?.G5_BendMarkLayer}
                          onChange={(e) => {
                            const value = e.target.value;
                            const dxfOptions = companySettingObj?.dxfOptionsSetting;
                            dxfOptions.G5_BendMarkLayer = value;
                            setCompanySettingObj((prevData) => ({
                              ...prevData,
                              dxfOptionsSetting: dxfOptions,
                            }));
                          }}
                          style={{ height: 28, width: '120px' }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row style={{ marginTop: 10 }}>
                  <Col span={2}>曲げ線種：谷</Col>
                  <Col span={22}>
                    <div style={{ display: 'flex' }}>
                      <Input
                        className="input-editable"
                        value={companySettingObj?.dxfOptionsSetting?.G5_BendLineTypeFront}
                        onChange={(e) => {
                          const value = e.target.value;
                          const dxfOptions = companySettingObj?.dxfOptionsSetting;
                          dxfOptions.G5_BendLineTypeFront = value;
                          setCompanySettingObj((prevData) => ({
                            ...prevData,
                            dxfOptionsSetting: dxfOptions,
                          }));
                        }}
                        style={{ height: 28, width: '120px' }}
                      ></Input>

                      <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: '14px', margin: 0 }}>曲げ線種：山</span>
                        <Input
                          className="input-editable"
                          value={companySettingObj?.dxfOptionsSetting?.G5_BendLineTypetBack}
                          onChange={(e) => {
                            const value = e.target.value;
                            const dxfOptions = companySettingObj?.dxfOptionsSetting;
                            dxfOptions.G5_BendLineTypetBack = value;
                            setCompanySettingObj((prevData) => ({
                              ...prevData,
                              dxfOptionsSetting: dxfOptions,
                            }));
                          }}
                          style={{ height: 28, width: '120px', marginLeft: 28 }}
                        />
                      </div>

                      <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: '14px', margin: 0 }}>ケガキ線</span>

                        <ColorPicker
                          panelRender={(panel) => <div className="custom-panel">{panel}</div>}
                          presets={[{ label: '基本色', colors: presetColors }]}
                          defaultValue="#0000FF"
                          value={companySettingObj?.dxfOptionsSetting?.G5_EtchingLineColor}
                          onChangeComplete={(value) => {
                            // setJellDOptions((prev) => ({ ...prev, G5_EtchingLineColor: value.toHexString() }));
                            const dxfOptions = companySettingObj?.dxfOptionsSetting;
                            dxfOptions.G5_EtchingLineColor = value.toHexString();
                            setCompanySettingObj((prevData) => ({
                              ...prevData,
                              dxfOptionsSetting: dxfOptions,
                            }));
                          }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        {/** CAMPATH */}
        <Row style={{ padding: 10, paddingTop: 5 }}>
          <Col span={24}>
            <div className="outer-box">
              <div className="box-title">CAMPATH</div>
              <div className="box-content">
                <Row>
                  <Col span={2}>展開図レイヤー</Col>
                  <Col span={22}>
                    <div style={{ display: 'flex' }}>
                      <Input
                        className="input-editable"
                        value={companySettingObj?.dxfOptionsSetting?.CAMPATH_FlatLayer}
                        onChange={(e) => {
                          const value = e.target.value;
                          const dxfOptions = companySettingObj?.dxfOptionsSetting;
                          dxfOptions.CAMPATH_FlatLayer = value;
                          setCompanySettingObj((prevData) => ({
                            ...prevData,
                            dxfOptionsSetting: dxfOptions,
                          }));
                        }}
                        style={{ height: 28, width: '120px' }}
                      ></Input>

                      <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: '14px', margin: 0 }}>穴レイヤー</span>
                        <Input
                          className="input-editable"
                          value={companySettingObj?.dxfOptionsSetting?.CAMPATH_HoleLayer}
                          onChange={(e) => {
                            const value = e.target.value;
                            const dxfOptions = companySettingObj?.dxfOptionsSetting;
                            dxfOptions.CAMPATH_HoleLayer = value;
                            setCompanySettingObj((prevData) => ({
                              ...prevData,
                              dxfOptionsSetting: dxfOptions,
                            }));
                          }}
                          style={{ height: 28, width: '120px', marginLeft: 42 }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row style={{ marginTop: 10 }}>
                  <Col span={2}>曲げ線レイヤー</Col>
                  <Col span={22}>
                    <div style={{ display: 'flex' }}>
                      <Input
                        className="input-editable"
                        value={companySettingObj?.dxfOptionsSetting?.CAMPATH_BendLayer}
                        onChange={(e) => {
                          const value = e.target.value;
                          const dxfOptions = companySettingObj?.dxfOptionsSetting;
                          dxfOptions.CAMPATH_BendLayer = value;
                          setCompanySettingObj((prevData) => ({
                            ...prevData,
                            dxfOptionsSetting: dxfOptions,
                          }));
                        }}
                        style={{ height: 28, width: '120px' }}
                      ></Input>

                      <div style={{ marginLeft: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: '14px', margin: 0 }}>曲げ方向レイヤー</span>
                        <Input
                          className="input-editable"
                          value={companySettingObj?.dxfOptionsSetting?.CAMPATH_BendMarkLayer}
                          onChange={(e) => {
                            const value = e.target.value;
                            const dxfOptions = companySettingObj?.dxfOptionsSetting;
                            dxfOptions.CAMPATH_BendMarkLayer = value;
                            setCompanySettingObj((prevData) => ({
                              ...prevData,
                              dxfOptionsSetting: dxfOptions,
                            }));
                          }}
                          style={{ height: 28, width: '120px' }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        {/** GENERAL */}
        <Row style={{ padding: 10, paddingTop: 5 }}>
          <Col span={24}>
            <div className="outer-box">
              <div className="box-title">GENERAL</div>
              <div className="box-content">
                {/** 連続性 */}
                <div className="outer-box-child">
                  <div className="box-content">
                    <Row>
                      <Col span={2}>連続性度</Col>
                      <Col span={22}>
                        <div style={{ display: 'flex' }}>
                          <Input
                            className="input-editable"
                            value={companySettingObj?.dxfOptionsSetting?.GENERAL_ContinuityAccuracy}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (isDecimal(value)) {
                                const dxfOptions = companySettingObj?.dxfOptionsSetting;
                                dxfOptions.GENERAL_ContinuityAccuracy = value;
                                setCompanySettingObj((prevData) => ({
                                  ...prevData,
                                  dxfOptionsSetting: dxfOptions,
                                }));
                              }
                            }}
                            onBlur={(e) => {
                              let value = Number(companySettingObj?.dxfOptionsSetting.GENERAL_ContinuityAccuracy) || 0;
                              // value = toDecimal(value, 5);
                              // if (value < 1) value = toDecimal(0, 5);
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_ContinuityAccuracy = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                            style={{ height: 28, width: '120px' }}
                          ></Input>

                          <Checkbox
                            style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                            key="gENERAL_EnableReadPartInfoText"
                            type="checkbox"
                            name={'gENERAL_EnableReadPartInfoText'}
                            id={'gENERAL_EnableReadPartInfoText'}
                            checked={companySettingObj?.dxfOptionsSetting?.GENERAL_EnableReadPartInfoText}
                            onChange={(e) => {
                              const value = e.target.checked;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_EnableReadPartInfoText = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            <span style={{ margin: 0 }}>部品情報文字列を読み込む。</span>
                          </Checkbox>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                {/** 認識要素 */}
                <div className="outer-box-child" style={{ marginTop: 10 }}>
                  <div className="box-content" style={{}}>
                    {/**  認識要素 */}
                    <Row style={{ paddingBottom: 7 }}>
                      <Col span={2}>認識要素</Col>
                      <Col span={3} style={{ textAlign: 'center' }}>
                        色
                      </Col>
                      <Col span={5} style={{ textAlign: 'center' }}>
                        線種
                      </Col>
                      <Col span={5} style={{ textAlign: 'center' }}>
                        レイヤー
                      </Col>
                    </Row>
                    {/** 寸法線 */}
                    <Row style={{ paddingBottom: 3 }}>
                      <Col span={2}>寸法線</Col>
                      <Col span={3} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            justifyContent: 'center', // 横方向中央寄せ
                            alignItems: 'center', // 縦方向中央寄せ
                          }}
                        >
                          <Checkbox
                            style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                            key="gENERAL_DimensionColorEnable"
                            type="checkbox"
                            name={'gENERAL_DimensionColorEnable'}
                            id={'gENERAL_DimensionColorEnable'}
                            checked={companySettingObj?.dxfOptionsSetting?.GENERAL_DimensionColorEnable}
                            onChange={(e) => {
                              const value = e.target.checked;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_DimensionColorEnable = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            <span style={{ margin: 0 }}>有効</span>
                          </Checkbox>

                          <ColorPicker
                            panelRender={(panel) => <div className="custom-panel">{panel}</div>}
                            presets={[{ label: '基本色', colors: presetColors }]}
                            defaultValue="#FFFFFF"
                            value={companySettingObj?.dxfOptionsSetting?.GENERAL_DimensionColor}
                            onChangeComplete={(value) => {
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_DimensionColor = value.toHexString();
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          />
                        </div>
                      </Col>
                      <Col span={5} style={{ textAlign: 'center' }}></Col>
                      <Col span={5} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            justifyContent: 'center', // 横方向中央寄せ
                            alignItems: 'center', // 縦方向中央寄せ
                          }}
                        >
                          <Checkbox
                            style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                            key="gENERAL_DimensionLayerEnable"
                            type="checkbox"
                            name={'gENERAL_DimensionLayerEnable'}
                            id={'gENERAL_DimensionLayerEnable'}
                            checked={companySettingObj?.dxfOptionsSetting?.GENERAL_DimensionLayerEnable}
                            onChange={(e) => {
                              const value = e.target.checked;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_DimensionLayerEnable = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            <span style={{ margin: 0 }}>有効</span>
                          </Checkbox>

                          <Input
                            className="input-editable"
                            value={companySettingObj?.dxfOptionsSetting?.GENERAL_DimensionLayer}
                            onChange={(e) => {
                              const value = e.target.value;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_DimensionLayer = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                            style={{ height: 28, width: '180px' }}
                          />
                        </div>
                      </Col>
                    </Row>
                    {/** 注記 */}
                    <Row style={{ paddingBottom: 3 }}>
                      <Col span={2}>注記</Col>
                      <Col span={3} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            justifyContent: 'center', // 横方向中央寄せ
                            alignItems: 'center', // 縦方向中央寄せ
                          }}
                        >
                          <Checkbox
                            style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                            key="gENERAL_NoteColorEnable"
                            type="checkbox"
                            name={'gENERAL_NoteColorEnable'}
                            id={'gENERAL_NoteColorEnable'}
                            checked={companySettingObj?.dxfOptionsSetting?.GENERAL_NoteColorEnable}
                            onChange={(e) => {
                              const value = e.target.checked;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_NoteColorEnable = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            <span style={{ margin: 0 }}>有効</span>
                          </Checkbox>

                          <ColorPicker
                            panelRender={(panel) => <div className="custom-panel">{panel}</div>}
                            presets={[{ label: '基本色', colors: presetColors }]}
                            defaultValue="#FF0000"
                            value={companySettingObj?.dxfOptionsSetting?.GENERAL_NoteColor}
                            onChangeComplete={(value) => {
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_NoteColor = value.toHexString();
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          />
                        </div>
                      </Col>
                      <Col span={5} style={{ textAlign: 'center' }}></Col>
                      <Col span={5} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            justifyContent: 'center', // 横方向中央寄せ
                            alignItems: 'center', // 縦方向中央寄せ
                          }}
                        >
                          <Checkbox
                            style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                            key="gENERAL_NoteLayerEnable"
                            type="checkbox"
                            name={'gENERAL_NoteLayerEnable'}
                            id={'gENERAL_NoteLayerEnable'}
                            checked={companySettingObj?.dxfOptionsSetting?.GENERAL_NoteLayerEnable}
                            onChange={(e) => {
                              const value = e.target.checked;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_NoteLayerEnable = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            <span style={{ margin: 0 }}>有効</span>
                          </Checkbox>

                          <Input
                            className="input-editable"
                            value={companySettingObj?.dxfOptionsSetting?.GENERAL_NoteLayer}
                            onChange={(e) => {
                              const value = e.target.value;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_NoteLayer = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                            style={{ height: 28, width: '180px' }}
                          />
                        </div>
                      </Col>
                    </Row>
                    {/** 曲げ線 */}
                    <Row style={{ paddingBottom: 3 }}>
                      <Col span={2}>曲げ線</Col>
                      <Col span={3} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            justifyContent: 'center', // 横方向中央寄せ
                            alignItems: 'center', // 縦方向中央寄せ
                          }}
                        >
                          <Checkbox
                            style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                            key="gENERAL_BendLineColorEnable"
                            type="checkbox"
                            name={'gENERAL_BendLineColorEnable'}
                            id={'gENERAL_BendLineColorEnable'}
                            checked={companySettingObj?.dxfOptionsSetting?.GENERAL_BendLineColorEnable}
                            onChange={(e) => {
                              const value = e.target.checked;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_BendLineColorEnable = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            <span style={{ margin: 0 }}>有効</span>
                          </Checkbox>

                          <ColorPicker
                            panelRender={(panel) => <div className="custom-panel">{panel}</div>}
                            presets={[{ label: '基本色', colors: presetColors }]}
                            defaultValue="#00FFFF"
                            value={companySettingObj?.dxfOptionsSetting?.GENERAL_BendLineColor}
                            onChangeComplete={(value) => {
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_BendLineColor = value.toHexString();
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          />
                        </div>
                      </Col>
                      <Col span={5} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            justifyContent: 'center', // 横方向中央寄せ
                            alignItems: 'center', // 縦方向中央寄せ
                          }}
                        >
                          <Checkbox
                            style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                            key="gENERAL_BendLineTypeEnable"
                            type="checkbox"
                            name={'gENERAL_BendLineTypeEnable'}
                            id={'gENERAL_BendLineTypeEnable'}
                            checked={companySettingObj?.dxfOptionsSetting?.GENERAL_BendLineTypeEnable}
                            onChange={(e) => {
                              const value = e.target.checked;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_BendLineTypeEnable = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            <span style={{ margin: 0 }}>有効</span>
                          </Checkbox>

                          <Select
                            style={{ width: 150, textAlign: 'left' }}
                            // className={'popup-select-input-style'}
                            popupMatchSelectWidth={false}
                            defaultValue={0}
                            id={'bendLen'}
                            name={'bendLen'}
                            value={companySettingObj?.dxfOptionsSetting?.GENERAL_BendLineType}
                            onChange={(e) => {
                              const value = e;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_BendLineType = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            {Continuous?.map((item, index) => (
                              <Select.Option key={index + 'benlen'} id={'benlen' + index} value={item.id}>
                                {item.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </Col>
                      <Col span={5} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            justifyContent: 'center', // 横方向中央寄せ
                            alignItems: 'center', // 縦方向中央寄せ
                          }}
                        >
                          <Checkbox
                            style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                            key="gENERAL_BendLineLayerEnable"
                            type="checkbox"
                            name={'gENERAL_BendLineLayerEnable'}
                            id={'gENERAL_BendLineLayerEnable'}
                            checked={companySettingObj?.dxfOptionsSetting?.GENERAL_BendLineLayerEnable}
                            onChange={(e) => {
                              const value = e.target.checked;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_BendLineLayerEnable = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            <span style={{ margin: 0 }}>有効</span>
                          </Checkbox>

                          <Input
                            className="input-editable"
                            value={companySettingObj?.dxfOptionsSetting?.GENERAL_BendLineLayer}
                            onChange={(e) => {
                              const value = e.target.value;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_BendLineLayer = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                            style={{ height: 28, width: '180px' }}
                          />
                        </div>
                      </Col>
                    </Row>
                    {/** ケガキ */}
                    <Row style={{ paddingBottom: 3 }}>
                      <Col span={2}>ケガキ</Col>
                      <Col span={3} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            justifyContent: 'center', // 横方向中央寄せ
                            alignItems: 'center', // 縦方向中央寄せ
                            gap: 8,
                          }}
                        >
                          <Checkbox
                            style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                            key="gENERAL_EtchingColorEnable"
                            type="checkbox"
                            name={'gENERAL_EtchingColorEnable'}
                            id={'gENERAL_EtchingColorEnable'}
                            checked={companySettingObj?.dxfOptionsSetting?.GENERAL_EtchingColorEnable}
                            onChange={(e) => {
                              const value = e.target.checked;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_EtchingColorEnable = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            <span style={{ margin: 0 }}>有効</span>
                          </Checkbox>

                          <ColorPicker
                            panelRender={(panel) => <div className="custom-panel">{panel}</div>}
                            presets={[{ label: '基本色', colors: presetColors }]}
                            defaultValue="#0000FF"
                            value={companySettingObj?.dxfOptionsSetting?.GENERAL_EtchingColor}
                            onChangeComplete={(value) => {
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_EtchingColor = value.toHexString();
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          />
                        </div>
                      </Col>
                      <Col span={5} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            justifyContent: 'center', // 横方向中央寄せ
                            alignItems: 'center', // 縦方向中央寄せ
                          }}
                        >
                          <Checkbox
                            style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                            key="gENERAL_EtchingLineTypeEnable"
                            type="checkbox"
                            name={'gENERAL_EtchingLineTypeEnable'}
                            id={'gENERAL_EtchingLineTypeEnable'}
                            checked={companySettingObj?.dxfOptionsSetting?.GENERAL_EtchingLineTypeEnable}
                            onChange={(e) => {
                              const value = e.target.checked;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_EtchingLineTypeEnable = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            <span style={{ margin: 0 }}>有効</span>
                          </Checkbox>

                          <Select
                            style={{ width: 150, textAlign: 'left' }}
                            // className={'popup-select-input-style'}
                            popupMatchSelectWidth={false}
                            defaultValue={0}
                            id={'bendLen'}
                            name={'bendLen'}
                            value={companySettingObj?.dxfOptionsSetting?.GENERAL_EtchingLineType}
                            onChange={(e) => {
                              const value = e;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_EtchingLineType = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            {Continuous?.map((item, index) => (
                              <Select.Option key={index + 'benlen'} id={'benlen' + index} value={item.id}>
                                {item.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </Col>
                      <Col span={5} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            justifyContent: 'center', // 横方向中央寄せ
                            alignItems: 'center', // 縦方向中央寄せ
                          }}
                        >
                          <Checkbox
                            style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                            key="gENERAL_EtchingLayerEnable"
                            type="checkbox"
                            name={'gENERAL_EtchingLayerEnable'}
                            id={'gENERAL_EtchingLayerEnable'}
                            checked={companySettingObj?.dxfOptionsSetting?.GENERAL_EtchingLayerEnable}
                            onChange={(e) => {
                              const value = e.target.checked;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_EtchingLayerEnable = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            <span style={{ margin: 0 }}>有効</span>
                          </Checkbox>

                          <Input
                            className="input-editable"
                            value={companySettingObj?.dxfOptionsSetting?.GENERAL_EtchingLayer}
                            onChange={(e) => {
                              const value = e.target.value;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_EtchingLayer = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                            style={{ height: 28, width: '180px' }}
                          />
                        </div>
                      </Col>
                    </Row>
                    {/** スリット */}
                    <Row style={{ paddingBottom: 3 }}>
                      <Col span={2}>スリット</Col>
                      <Col span={3} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            justifyContent: 'center', // 横方向中央寄せ
                            alignItems: 'center', // 縦方向中央寄せ
                          }}
                        >
                          <Checkbox
                            style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                            key="gENERAL_SlitColorEnable"
                            type="checkbox"
                            name={'gENERAL_SlitColorEnable'}
                            id={'gNERAL_SlitColorEnable'}
                            checked={companySettingObj?.dxfOptionsSetting?.GENERAL_SlitColorEnable}
                            onChange={(e) => {
                              const value = e.target.checked;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_SlitColorEnable = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            <span style={{ margin: 0 }}>有効</span>
                          </Checkbox>

                          <ColorPicker
                            panelRender={(panel) => <div className="custom-panel">{panel}</div>}
                            presets={[{ label: '基本色', colors: presetColors }]}
                            defaultValue="#FFBF00"
                            value={companySettingObj?.dxfOptionsSetting?.GENERAL_SlitColor}
                            onChangeComplete={(value) => {
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_SlitColor = value.toHexString();
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          />
                        </div>
                      </Col>
                      <Col span={5} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            justifyContent: 'center', // 横方向中央寄せ
                            alignItems: 'center', // 縦方向中央寄せ
                          }}
                        >
                          <Checkbox
                            style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                            key="gENERAL_SlitLineTypeEnable"
                            type="checkbox"
                            name={'gENERAL_SlitLineTypeEnable'}
                            id={'gENERAL_SlitLineTypeEnable'}
                            checked={companySettingObj?.dxfOptionsSetting?.GENERAL_SlitLineTypeEnable}
                            onChange={(e) => {
                              const value = e.target.checked;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_SlitLineTypeEnable = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            <span style={{ margin: 0 }}>有効</span>
                          </Checkbox>

                          <Select
                            style={{ width: 150, textAlign: 'left' }}
                            // className={'popup-select-input-style'}
                            popupMatchSelectWidth={false}
                            defaultValue={0}
                            id={'bendLen'}
                            name={'bendLen'}
                            value={companySettingObj?.dxfOptionsSetting?.GENERAL_SlitLineType}
                            onChange={(e) => {
                              const value = e;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_SlitLineType = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            {Continuous?.map((item, index) => (
                              <Select.Option key={index + 'benlen'} id={'benlen' + index} value={item.id}>
                                {item.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </Col>
                      <Col span={5} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            justifyContent: 'center', // 横方向中央寄せ
                            alignItems: 'center', // 縦方向中央寄せ
                          }}
                        >
                          <Checkbox
                            style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                            key="gENERAL_SlitLayerEnable"
                            type="checkbox"
                            name={'gENERAL_SlitLayerEnable'}
                            id={'gENERAL_SlitLayerEnable'}
                            checked={companySettingObj?.dxfOptionsSetting?.GENERAL_SlitLayerEnable}
                            onChange={(e) => {
                              const value = e.target.checked;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_SlitLayerEnable = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            <span style={{ margin: 0 }}>有効</span>
                          </Checkbox>

                          <Input
                            className="input-editable"
                            value={companySettingObj?.dxfOptionsSetting?.GENERAL_SlitLayer}
                            onChange={(e) => {
                              const value = e.target.value;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_SlitLayer = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                            style={{ height: 28, width: '180px' }}
                          />
                        </div>
                      </Col>
                    </Row>
                    {/** 面の */}
                    <Row style={{ paddingBottom: 3 }}>
                      <Col span={2}>面</Col>
                      <Col span={3} style={{ textAlign: 'center' }}></Col>
                      <Col span={5} style={{ textAlign: 'center' }}></Col>
                      <Col span={5} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            justifyContent: 'center', // 横方向中央寄せ
                            alignItems: 'center', // 縦方向中央寄せ
                          }}
                        >
                          <Checkbox
                            style={{ fontSize: '14px', marginLeft: 15, alignItems: 'center' }}
                            key="gENERAL_ProfileLayerEnable"
                            type="checkbox"
                            name={'gENERAL_ProfileLayerEnable'}
                            id={'gENERAL_ProfileLayerEnable'}
                            checked={companySettingObj?.dxfOptionsSetting?.GENERAL_ProfileLayerEnable}
                            onChange={(e) => {
                              const value = e.target.checked;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_ProfileLayerEnable = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                          >
                            <span style={{ margin: 0 }}>有効</span>
                          </Checkbox>

                          <Input
                            className="input-editable"
                            value={companySettingObj?.dxfOptionsSetting?.GENERAL_ProfileLayer}
                            onChange={(e) => {
                              const value = e.target.value;
                              const dxfOptions = companySettingObj?.dxfOptionsSetting;
                              dxfOptions.GENERAL_ProfileLayer = value;
                              setCompanySettingObj((prevData) => ({
                                ...prevData,
                                dxfOptionsSetting: dxfOptions,
                              }));
                            }}
                            style={{ height: 28, width: '180px' }}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <Row style={{ marginTop: '1rem' }}>
        <Col span={14} style={{ textAlign: 'right' }}>
          <Button
            className="mainButton"
            onClick={() => {
              setSaveConfirm(userSettingInfo?.massages?.editOk);
              if (!userSettingInfo?.massages?.editOk) {
                updConfirmOk();
              }
            }}
          >
            保存
          </Button>
        </Col>
      </Row>
    </div>
  );

  //会社登録
  const createNewCompanySetting = (
    <>
      <Row className="mt-4">
        <label style={{ fontWeight: 800, fontSize: '13.5px' }}>会社登録</label>
      </Row>
      <div style={{ marginLeft: '1.5rem' }} className="settingContent">
        {/** 会社名 */}
        <Row className="mt-2">
          <label>会社名</label>
        </Row>
        <Row className="mt-1">
          <Col span={7}>
            <Input
              name="cmpNm"
              value={companyMst?.compNm}
              onChange={(e) => {
                setCompanyMst((prevData) => ({
                  ...prevData,
                  compNm: e.target.value,
                }));
              }}
              style={{ padding: 5 }}
              className="input-editable"
            />
          </Col>
        </Row>
        {/** ZF管理者ID */}
        <Row className="mt-2">
          <label>ZF管理者ID</label>
        </Row>
        <Row className="mt-1">
          <Col span={7}>
            <Input
              name="mgnAddr"
              value={companyMst?.mailAddress}
              onChange={(e) => {
                if (ALLOWED_REGEX.test(e.target.value)) {
                  setCompanyMst((prevData) => ({
                    ...prevData,
                    mailAddress: e.target.value,
                  }));
                }
              }}
              style={{ padding: 5 }}
              className="input-editable percent-input "
            />
          </Col>
        </Row>
        {/** 氏名 */}
        <Row className="mt-2">
          <label>氏名</label>
        </Row>
        <Row className="mt-1">
          <Col span={4}>
            <Input
              name="mngNm"
              value={companyMst?.userNm}
              onChange={(e) => {
                setCompanyMst((prevData) => ({
                  ...prevData,
                  userNm: e.target.value,
                }));
              }}
              style={{ padding: 5 }}
              className="input-editable percent-input "
            />
          </Col>
        </Row>
        {/** パスワード */}
        <Row className="mt-2">
          <label>パスワード</label>
        </Row>
        <Row className="mt-1">
          <Col span={4}>
            <Input.Password
              name="mngPwd"
              value={companyMst?.password}
              onChange={(e) => {
                if (ALLOWED_REGEX.test(e.target.value)) {
                  setCompanyMst((prevData) => ({
                    ...prevData,
                    password: e.target.value,
                  }));
                }
              }}
              style={{ padding: 5 }}
              className="input-editable percent-input "
            />
          </Col>
        </Row>
        {/** 権限 */}
        <Row className="mt-2">
          <label>権限</label>
        </Row>
        <Row className="mt-1">
          <Col span={4}>
            <Select
              disabled={true}
              style={{ width: 120, textAlign: 'left' }}
              popupMatchSelectWidth={false}
              defaultValue={1}
              id={'cmpRole'}
              name={'cmpRole'}
              value={CompanyRole[0]?.id}
            >
              {CompanyRole?.map((item, index) => (
                <Select.Option key={index + 'benlen'} id={'benlen' + index} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
        {/** 登録ボタン */}
        <Row style={{ marginTop: '3rem' }}>
          <Col span={7} style={{ textAlign: 'right' }}>
            <Button
              className="mainButton"
              onClick={() => {
                setRegConfirm(true);
              }}
            >
              登録
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );

  //ユーザー登録
  const createNewUserSetting = (
    <>
      <Row className="mt-4">
        <label style={{ fontWeight: 800, fontSize: '13.5px' }}>ユーザー登録</label>
      </Row>
      <div style={{ marginLeft: '1.5rem' }} className="settingContent">
        {/** ユーザーID */}
        <Row className="mt-2">
          <label>ユーザーID</label>
        </Row>
        <Row className="mt-1">
          <Col span={7}>
            <Input
              name="cmpNm"
              value={userMst?.mailAddress}
              onChange={(e) => {
                if (ALLOWED_REGEX.test(e.target.value)) {
                  setUserMst((prevData) => ({
                    ...prevData,
                    mailAddress: e.target.value,
                  }));
                }
              }}
              style={{ padding: 5 }}
              className="input-editable"
            />
          </Col>
        </Row>
        {/** 氏名 */}
        <Row className="mt-2">
          <label>氏名</label>
        </Row>
        <Row className="mt-1">
          <Col span={4}>
            <Input
              name="mgnAddr"
              value={userMst?.userNm}
              onChange={(e) => {
                setUserMst((prevData) => ({
                  ...prevData,
                  userNm: e.target.value,
                }));
              }}
              style={{ padding: 5 }}
              className="input-editable percent-input "
            />
          </Col>
        </Row>
        {/** 権限 */}
        <Row className="mt-2">
          <label>権限</label>
        </Row>
        <Row className="mt-1">
          <Col span={4}>
            <Select
              style={{ width: 120, textAlign: 'left' }}
              popupMatchSelectWidth={false}
              defaultValue={2}
              id={'cmpRole'}
              name={'cmpRole'}
              value={userMst.userRole}
              onChange={(e) => {
                setUserMst((prevData) => ({
                  ...prevData,
                  userRole: e,
                }));
              }}
            >
              {CompanyRole?.map((item, index) => (
                <Select.Option key={index + 'benlen'} id={'benlen' + index} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
        {/** 登録ボタン */}
        <Row style={{ marginTop: '3rem' }}>
          <Col span={7} style={{ textAlign: 'right' }}>
            <Button
              className="mainButton"
              onClick={() => {
                setRegConfirm(true);
              }}
            >
              登録
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );

  async function addCompanySetting(companySetting) {
    let ret = [];
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'CompanySetting';
      const otherParam = {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
        body: JSON.stringify({
          companySettingType: selectedAdminItem,
          Langs: companySetting.languages,
          Envs: companySetting.environments,
          InitNames: companySetting.initNames,
          ExcelFormats: companySetting.excelFormats,
          CSVFormats: companySetting.csvFormats,
          PrintOutputs: companySetting.printOutputs,
          CSVOutputs: companySetting.csvOutputs,
          SettingInfo: companySetting.info,
          downloadFormatId: 0,
          DxfTypeCode: companySetting.dxfTypeCode,
          DxfOptionsSetting: companySetting.dxfOptionsSetting,
        }),
      };

      await fetch(Url, otherParam)
        .then(async (response) => {
          return await response.json();
        })
        .then((data) => {
          if (data && data?.updateToken) {
            // セクションにトークン情報を更新する
            updateAccessToken(data?.updateToken);
          }
          if (data && data.statusCode === StatusCodes.OK) {
            ret = data.data[0];
            if (ret) {
              props?.showCompleteMsg();
              setCompanySettingBefore(JSON.parse(JSON.stringify(companySettingObj)));
            }
          } else if (
            data &&
            (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)
          ) {
            authorizeError(ErrorMessage()[data?.messageCode]);
            return;
          } else if (data && data.statusCode !== StatusCodes.OK) {
            if (data?.messageCode == 'E020' || data?.messageCode == 'E007') {
              let errorMsg = '';
              if (data?.messageCode === 'E020') {
                errorMsg = ErrorMessage('ファイル名「' + data.detailMessage + '」')[data?.messageCode];
              } else if (data?.messageCode === 'E007') {
                errorMsg =
                  '出力ファイルを選択してください。選択物がない場合、出力フォーマットにフォーマットをさきに設定してください。';
              }

              error(errorMsg);
              return;
            } else {
              error(ErrorMessage()[data?.messageCode]);
              return;
            }
          }
        })
        .catch((e) => {
          authorizeError(ErrorMessage().E010);
          return;
        });
    } catch (e) {
      error(e.message);
      return;
    }
    ret?.length > 0 && ret != undefined ? setIsExist(true) : setIsExist(false);
    return ret;
  }

  async function updateCompanySetting(companySetting) {
    let ret = [];
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'CompanySetting';
      const otherParam = {
        method: 'PUT',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
        body: JSON.stringify({
          companySettingType: selectedAdminItem,
          Langs: companySetting.languages,
          Envs: companySetting.environments,
          InitNames: companySetting.initNames,
          ExcelFormats: companySetting.excelFormats,
          CSVFormats: companySetting.csvFormats,
          PrintOutputs: companySetting.printOutputs,
          CSVOutputs: companySetting.csvOutputs,
          SettingInfo: companySetting.info,
          DxfTypeCode: companySetting.dxfTypeCode,
          DxfOptionsSetting: companySetting.dxfOptionsSetting,
        }),
      };

      await fetch(Url, otherParam)
        .then(async (response) => {
          return await response.json();
        })
        .then((data) => {
          if (data && data?.updateToken) {
            // セクションにトークン情報を更新する
            updateAccessToken(data?.updateToken);
          }
          if (data && data.statusCode === StatusCodes.OK) {
            ret = data.data[0];
            if (ret) {
              props?.showCompleteMsg();
              setCompanySettingBefore(JSON.parse(JSON.stringify(companySettingObj)));
            }
          } else if (
            data &&
            (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)
          ) {
            authorizeError(ErrorMessage()[data?.messageCode]);
            return;
          } else if (data && data.statusCode !== StatusCodes.OK) {
            if (data?.messageCode == 'E020' || data?.messageCode == 'E007') {
              let errorMsg = '';
              if (data?.messageCode === 'E020') {
                errorMsg = ErrorMessage('ファイル名「' + data.detailMessage + '」')[data?.messageCode];
              } else if (data?.messageCode === 'E007') {
                errorMsg =
                  '出力ファイルを選択してください。選択物がない場合、出力フォーマットにフォーマットをさきに設定してください。';
              }
              error(errorMsg);
              return;
            } else {
              error(ErrorMessage()[data?.messageCode]);
              return;
            }
          }
        })
        .catch((e) => {
          authorizeError(ErrorMessage().E010);
          return;
        });
    } catch (e) {
      error(e.message);
      return;
    }
    return ret;
  }

  const updConfirmOk = async (e) => {
    companySettingObj.excelFormats = excelFilesList;
    if (isExist) {
      await updateCompanySetting(companySettingObj);
    } else {
      await addCompanySetting(companySettingObj);
    }
    setSaveConfirm(false);
  };

  const updConfirmCancel = () => {
    setSaveConfirm(false);
    setRegConfirm(false);
  };

  const createCmpMstConfirmOk = async (e) => {
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'CompanyMaster';
      const otherParam = {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
        body: JSON.stringify({
          companyMasterName: companyMst.compNm,
          mailAddress: companyMst.mailAddress,
          userName: companyMst.userNm,
          password: companyMst.password,
        }),
      };

      await fetch(Url, otherParam)
        .then((data) => {
          if (data && data.status === StatusCodes.OK) {
            props?.showCompleteMsg();
          } else if (data && data.status === StatusCodes.UNAUTHORIZED) {
            error('アクセス権限がありません。');
          } else if (data && data.status === StatusCodes.CONFLICT) {
            error('入力されたユーザーIDは既に登録されています。');
          } else {
            error(ErrorMessage()['E013']);
          }
          setRegConfirm(false);
        })
        .catch((e) => {
          error(ErrorMessage()['E013']);
        });
    } catch (e) {
      error(e.message);
    }
    setSaveConfirm(false);
  };

  const createUserMstConfirmOk = async (e) => {
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'UserMaster';
      const otherParam = {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
        body: JSON.stringify({
          mailAddress: userMst.mailAddress,
          userName: userMst.userNm,
          userRole: userMst.userRole,
        }),
      };

      await fetch(Url, otherParam)
        .then((data) => {
          if (data && data.status === StatusCodes.OK) {
            props?.showCompleteMsg();
          } else if (data && data.status === StatusCodes.UNAUTHORIZED) {
            error('アクセス権限がありません。');
          } else if (data && data.status === StatusCodes.CONFLICT) {
            error('入力されたユーザーIDは既に登録されています。');
          } else {
            error(ErrorMessage()['E013']);
          }
          setRegConfirm(false);
        })
        .catch((e) => {
          error(ErrorMessage()['E013']);
        });
    } catch (e) {
      error(e.message);
    }
    setSaveConfirm(false);
  };

  // 表示するフォーム
  const displayForm = (selectedAdminItem) => {
    if (selectedAdminItem === '0') {
      return adminLanguageSetting;
    } else if (selectedAdminItem === '1') {
      return environmentSetting;
    } else if (selectedAdminItem === '2') {
      // IQX_WEBEST-241 会社設定において見積データ、子部品データ追加時の自動入力される名称の変更する機能
      return defaultNameSetting;
    } else if (selectedAdminItem === '3') {
      return exportSetting;
    } else if (selectedAdminItem === '4') {
      return reportSetting;
    } else if (selectedAdminItem === '5') {
      // dxfTypeOptionの初期値
      return dxfOptionSetting;
    } else if (selectedAdminItem === '6') {
      // 会社作成
      return createNewCompanySetting;
    } else if (selectedAdminItem === '7') {
      // ユーザ作成
      return createNewUserSetting;
    } else if (selectedAdminItem === '8') {
      // ユーザー管理
      return <UserMasterList userMasterListClick={true} />;
    }
  };

  // IQX_WEBEST-273 帳票のExcelをダウンロードしたい IQX_WEBEST-274 帳票のExcelを削除したい
  const downloadOk = async (id, fileNm) => {
    if (document.getElementById('rf' + deleteFileId)) {
      document.getElementById('rf' + deleteFileId).style.backgroundColor = 'white';
    }
    setDeleteFileNm(fileNm);
    setDeleteFileId(id);
    if (document.getElementById('rf' + id)) {
      document.getElementById('rf' + id).style.backgroundColor = '#fcfade';
    }
    const ExcelJS = require('exceljs');
    const s3Stream = await downloadS3FileContent(fileNm);
    if (s3Stream) {
      const workbookIndividual = new ExcelJS.Workbook();
      await workbookIndividual.xlsx.load(s3Stream);
      let uint8Array = await workbookIndividual.xlsx.writeBuffer();
      let blob = new Blob([uint8Array], { type: 'application/octet-binary' });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileNm;
      link.click();
      link.remove();
    }
  };

  // IQX_WEBEST-273 帳票のExcelをダウンロードしたい
  const downloadCancel = () => {
    setIsFileDownloadModal(false);
  };

  //  IQX_WEBEST-274 帳票のExcelを削除したい
  const deleteClick = (fileId, fileNm) => {
    if (document.getElementById('rf' + deleteFileId)) {
      document.getElementById('rf' + deleteFileId).style.backgroundColor = 'white';
    }
    setIsDelete(true);
    setDeleteFileNm(fileNm);
    setDeleteFileId(fileId);
    if (document.getElementById('rf' + fileId)) {
      document.getElementById('rf' + fileId).style.backgroundColor = '#fcfade';
    }
  };

  //  IQX_WEBEST-274 帳票のExcelを削除したい
  const deleteOk = async () => {
    setIsDelete(false);
    const result = await deleteS3FileContent(deleteFileNm);
    if (result) {
      complete('データ削除は正常に完了しました。');
      var uploadFiles = await getFileList();
      setUploadedFileLst(uploadFiles);
      if (document.getElementById('rf' + deleteFileId)) {
        document.getElementById('rf' + deleteFileId).style.backgroundColor = 'white';
      }
    }
  };

  //  IQX_WEBEST-274 帳票のExcelを削除したい
  const deleteCancel = () => {
    setIsDelete(false);
  };

  // IQX_WEBEST-273 帳票のExcelをダウンロードしたい IQX_WEBEST-274 帳票のExcelを削除したい
  const childModalTitle = (
    <div
      style={{
        width: 850,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>ファイル一覧表示</p>
    </div>
  );

  // IQX_WEBEST-274 帳票のExcelを削除したい
  const deleteFileContent = <p style={{ fontSize: '13.5px' }}>ファイルを削除します。よろしいでしょうか。</p>;

  return (
    <>
      <div>{displayForm(selectedAdminItem)}</div>
      {/* {CSVSettingModal ? <CSVSetting csvModal={CSVSettingModal} /> : ''} */}

      {/** 新規追加破棄確認ポップアップ */}
      {saveConfirm &&
        commonResponsiveConfirmModal(
          saveConfirm,
          confirmModalTitle,
          commonFooter(updConfirmOk, updConfirmCancel),
          null,
          400,
          updConfirmOk,
          updConfirmCancel,
          confirmUpdateContent,
          null,
          null,
          false
        )}
      {/** 登録破棄確認ポップアップ */}
      {regConfirm &&
        commonResponsiveConfirmModal(
          regConfirm,
          confirmModalTitle,
          commonFooter(selectedAdminItem === '6' ? createCmpMstConfirmOk : createUserMstConfirmOk, updConfirmCancel),
          null,
          400,
          selectedAdminItem === '6' ? createCmpMstConfirmOk : createUserMstConfirmOk,
          updConfirmCancel,
          confirmCreateContent,
          null,
          null,
          false
        )}
      {/* ファイル一覧表示　IQX_WEBEST-273 帳票のExcelをダウンロードしたい  IQX_WEBEST-274 帳票のExcelを削除したい*/}
      <Modal
        maskClosable={false}
        title={childModalTitle}
        open={isFileDownloadModal}
        onCancel={downloadCancel}
        width={850}
        style={{ top: 230 }}
        closeIcon={<CloseOutlined style={{ color: 'white' }} />}
        footer={[]}
      >
        <div style={{ width: '100%', height: 460, overflow: 'auto', marginTop: 15 }}>
          <Row className="oyabuhin-row oyabuhin-row-bg">
            <Col span={2} className="oyabuhin-detail-col">
              <div style={{ fontWeight: 600, fontSize: '17px' }}>
                <span>No</span>
              </div>
            </Col>
            <Col span={18} className="oyabuhin-detail-col">
              <div style={{ marginTop: 2, fontWeight: 600, fontSize: '15px' }}>
                <span>ファイル名</span>
              </div>
            </Col>
            <Col span={2} className="oyabuhin-detail-col"></Col>
            <Col span={2} className="oyabuhin-detail-col"></Col>
          </Row>

          {uploadedFileLst?.map((item, index) => (
            <Row className="oyabuhin-row" id={'rf' + item.id}>
              <Col span={2} className="oyabuhin-detail-col">
                <div style={{ marginTop: 5, fontSize: '15px' }}>
                  <span>{index + 1}</span>
                </div>
              </Col>
              <Col span={18} className="oyabuhin-detail-col">
                <div style={{ marginTop: 5, textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '15px' }}>
                  <Popover content={item.label}>
                    <span>{item.label}</span>
                  </Popover>
                </div>
              </Col>
              <Col span={2} className="oyabuhin-detail-col" style={{ textAlign: 'center', backgroundColor: 'white' }}>
                <CloudDownloadOutlined className="download-icon" onClick={(e) => downloadOk(item.id, item.label)} />
              </Col>
              <Col span={2} className="oyabuhin-detail-col" style={{ textAlign: 'center', backgroundColor: 'white' }}>
                <CloseCircleFilled
                  className="download-delete-icon"
                  style={{ marginTop: 3 }}
                  onClick={(e) => deleteClick(item.id, item.label)}
                />
              </Col>
            </Row>
          ))}
        </div>
      </Modal>
      {/* 削除 IQX_WEBEST-274 帳票のExcelを削除したい */}
      {isDelete
        ? commonResponsiveConfirmModal(
            isDelete,
            confirmModalTitle,
            commonDeleteFooter(deleteOk, deleteCancel),
            null,
            400,
            deleteOk,
            deleteCancel,
            deleteFileContent,
            null,
            { top: 150 },
            false
          )
        : ''}
    </>
  );
});

export default CompanySetting;
